<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <!-- Create Content Action | Title Pages -->
        <div class="d-flex flex-row justify-content-between align-items-center firstheader">

            <!-- Title Pages  -->
            <h1>{{ datainfo[0].title }} Content 
                <span @click="showBox('helperinfobox')" class="helperinfo ml-2" id="helperinfo">
                    <img :src="helpeicon" alt="Page Content Help" style="width: 2rem;height: auto;">
                </span>
            </h1>

            <!-- Helper Infobox -->
            <div class="helperinfobox d-none">

                <div class="infobox d-flex flex-column justify-content-center align-items-center">

                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="predefaultel-tab" data-bs-toggle="tab" data-bs-target="#predefaultel-tab-pane" type="button" role="tab" aria-controls="predefaultel-tab-pane" aria-selected="true">
                                Pre-default Containers
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="sections-tab" data-bs-toggle="tab" data-bs-target="#sections-tab-pane" type="button" role="tab" aria-controls="sections-tab-pane" aria-selected="false">
                                Sections
                            </button>
                        </li>
                    </ul>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="predefaultel-tab-pane" role="tabpanel" aria-labelledby="predefaultel-tab" tabindex="0">
                            <ul class="list-group">
        
                                <li v-for="(value, index) in Object.values(predefaulthtmlelementslist)" :key="index" class="list-group-item">
        
                                    <div class="d-flex flex row w-100">
        
                                        <strong class="order-1">{{ value.method }}</strong>
                                        <p class="order-2">{{ value.description }}</p>
        
                                    </div>
        
                                </li>
        
                            </ul>
                        </div>
                        <div class="tab-pane fade" id="sections-tab-pane" role="tabpanel" aria-labelledby="sections-tab" tabindex="0">
                            <ul class="list-group">
        
                                <li v-for="(value, index) in Object.values(sectionelementslist)" :key="index" class="list-group-item">
        
                                    <div class="d-flex flex row w-100">
        
                                        <strong class="order-1">{{ value.method }}</strong>
                                        <p class="order-2">{{ value.description }}</p>
        
                                    </div>
        
                                </li>
        
                            </ul>
                        </div>
                    </div>

                </div>

            </div>

            <!-- Page Content BTN Actions -->
            <div class="d-flex flex-row justify-content-around ms-5" style="width:auto;">

                <button v-if="Object.values(alldata).length > 0"
                    type="button"
                    class="btn btn-secondary orderbtn"
                    id="orderbtn"
                    @click="orderContent"
                >
                    Order
                </button>

                <button 
                    @click="addFieldsetContent(
                        'fieldsetbase',
                        true
                    )" 
                    type="button" 
                    class="btn btn-primary ms-3"
                >Add</button>
                
                <button
                    @click="previewRoutine('preview')" 
                    type="button" 
                    class="btn btn-info ms-3"
                >Preview</button>

                <button
                    @click="onlyShowModal('insertmedia')" 
                    class="btn btn-primary ms-3"
                    type="button"
                >
                    Add Image
                </button>

                <!-- <button 
                    class="btn btn-primary ms-3" 
                    type="button"
                    @click="groupContainer()"
                >Group</button> -->

            </div>
          
        </div>

        <!-- Form Structure -->
        <form @submit.prevent="sendData" action="" method="" class="form-pagescontent" enctype="multipart/form-data" autocomplete="on">

            <div 
                class="fieldsetbase" 
                @click="actionButtons($event)"
                @change="fileData($event)"
                @focusin="checkInputDataByFocus($event), groupContainerByLegend($event), cloneHtmlContent($event)"
                @focusout="checkInputDataByFocus($event), groupContainerByLegend($event), cloneHtmlContent($event)"
                @keyup="cloneHtmlContent($event)"
                @keydown="cloneHtmlContent($event)"
                ref="fieldsetbase"
            >

                <fieldset  
                    class="fieldset-pagescontent content1" 
                    data-fieldset="1" 
                    data-contentorder="1"
                    data-contentid="1"
                >

                    <!-- Accordean Base Action -->
                    <div class="d-flex flex-row justify-content-between align-items-center divaccordeon divaccordeon1">
    
                        <legend 
                            aria-describedby="change title" 
                            class="'mb-3 order-1 legendcontent1" 
                            data-value="contentname"
                            data-validation="5" 
                            contenteditable="true">Content</legend>

                        <button 
                            class="order-2 btn btn-danger removecontent1" 
                            type="button" 
                            data-value="removecontent" 
                            style="margin-right:.25rem;"
                        >Remove</button>
    
                        <button 
                            type="button" 
                            class="order-3 btn btn-secondary btnaccordeon1" 
                            data-value="accordeon"
                            style="margin-right:.25rem;"
                        >Show</button>

                        <!-- Active Content -->
                        <div 
                            class="d-flex flex-row order-4 activeorderbase activeorderbase1"
                            style="margin-bottom:1.1rem;margin-right:.25rem;"
                        >

                            <div class="d-flex flex-column order-1 activebase activebase1">

                                <span class="order-1">Active</span>
                                <button 
                                    type="button" 
                                    class="order-2 btn btn-light btnactive" 
                                    data-value="activecontent"
                                    data-fieldset="1" 
                                    data-contentorder="1"
                                    data-contentid="1"
                                    data-actionactive="insert"
                                >Yes</button>

                            </div>

                            <div class="d-flex flex-column order-2 orderbase orderbase1">

                                <span class="order-1">Order</span>
                                <span 
                                    class="order-2 ordercontent"
                                    data-fieldset="1" 
                                    data-contentorder="1"
                                    data-contentid="1"
                                    style="font-weight:bolder;border: .1px solid #333;padding: .3rem;text-align: center;"
                                    contenteditable="true"
                                >
                                1
                                </span>

                            </div>

                        </div>
    
                    </div>
                    
                    <!-- Input Base Section -->
                    <div class="inputbase d-none inputbase1">
    
                        <!-- Btn action section create -->
                        <div 
                        class="btnbasesectioncreate btnbasesectioncreate1 mb-3 d-flex flex-column justify-content-center align-items-center">
    
                            <span class="titlebtnsectioncreate order-1 my-3 titlebtnsectioncreate1">
                                Create a Section
                            </span>
    
                            <div 
                            class="d-flex flex-row justify-content-around align-items-center order-2 btnsectioncreate mb-3 btnsectioncreate1">
    
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="classsection"
                                    data-inputbase="inputbase1" 
                                >Classname</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="titlesection"
                                    data-inputbase="inputbase1"    
                                >Title</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="subtitlesection"
                                    data-inputbase="inputbase1"   
                                >Subtitle</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="filesection"
                                    data-inputbase="inputbase1"    
                                >File</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="descriptionsection"
                                    data-inputbase="inputbase1"  
                                >Description</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="ctasection"
                                    data-inputbase="inputbase1"  
                                >CTA</button>
                                <button 
                                    class="btn btn-dark" 
                                    type="button"
                                    data-value="htmlsection"
                                    data-inputbase="inputbase1"  
                                >HTML</button>
    
                            </div>
                            
                        </div>
    
                    </div>
    
                </fieldset>

            </div>

            <button type="submit" class="btn btn-primary float-end my-3 btnform" :disabled="disabled">{{ btntext }}</button>

        </form>

        <!-- Modal for Select Image -->
        <modal
            title="Select Image"
            classname="baseselectimage"
        >

            <template #modalcontent>

                <!-- Media List -->
                <media-list
                    :allmediafiles="allmediafiles"
                    @choose-image="chooseImage($event)"
                />

            </template>

        </modal>

        <!-- Modal for Insert Media -->
        <modal
            title="Insert Media"
            classname="insertmedia"
        >

            <template #modalcontent>

                <!-- Insert Media Element -->
                <insert-media 
                    :csrftolken="csrftolken"
                    :mediainsert="mediainsert"
                    modalclassname="insertmedia"
                    responseclassname="responsebasemessage"
                    :removeresponsemessages="removeResponseMessages"
                    :checklocalstorage="checkLocalStorage"
                />

            </template>

        </modal>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>

</template>
<script>
import fetchData from './../../fetchData.js';
import htmlElements from './../../htmlElements.js';
import validation from './../../inputValidation.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Modal from './../elements/ModalElement.vue';
import MediaList from './../elements/MediaListElement.vue';
import InsertMedia from './../elements/MediaInsertElement.vue';

//Set Use Strict
"use strict";


export default{
    name:'PagesContentComponent',
    props:{

        datapage:{
            type: String,
            required: true
        },
        csrftolken:{
            type: String,
            required: true
        },
        pagescontentcreate:{
            type: String,
            required: true
        },
        pagescontentupdate:{
            type: String,
            required: true
        },
        pagecontent:{
            type: String,
            required: true
        },
        imagestoragepath:{
            type: String,
            required: true
        },
        pagescontentremove:{
            type: String,
            required: true
        },
        pageactive:{
            type: String,
            required: true
        },
        pagescontentorder:{
            type: String,
            required: true
        },
        predefaulthtmlelements:{
            type: String,
            required: true
        },
        helpeicon:{
            type: String,
            required: true
        },
        sectionelementsdescription:{
            type: String,
            required: true
        },
        activelayout:{
            type: String,
            required: true
        },
        allpageswithallcontents:{
            type: String,
            required: true
        },
        pagepreview:{
            type: String,
            required: true
        },
        pagestorepreview:{
            type: String,
            required: true
        },
        pageactivepreview:{
            type: String,
            required: true
        },
        mediainsert:{
            type: String,
            required: true
        },

    },
    data: () => {

        return {

            alldata: {},
            datainfo: {},
            btntext: '',
            ordercontentdefault: 1,
            counterfieldset: 1,
            counter: 1,
            countersection: 1,
            counterclassinput: 1,
            countertitleinput: 1,
            countersubtitleinput: 1,
            counterfileinput: 1,
            counterdescriptioninput: 1,
            counterhtmlinput: 1,
            counterctainput: 1,
            alertgigabyte: 1024 * 1024 * 1000 * 2,
            disabled: true,
            filedataform: {},
            formaction: '',
            alldata: {},
            fieldsetdata: {},
            dataSection: {},
            filedataformlist: [],
            filedataformupdatelist: [],
            contentidrefer: [],
            contentidreferpreview: [],
            imageIdCounter: 0,
            orderbaselist: [],
            orderbaselistoriginal: [],
            activeclass: 'd-flex',
            randomInputNum: 1,
            predefaulthtmlelementslist: {},
            sectionelementslist:{},
            layoutactive: "",
            allmediafiles: {},
            allmediafileslocalstorage: {},
            previwActiveRoutine: false,
            filedataformlistpreview: [],
            filedataformupdatelistpreview: [],
            checkImageUrlConditional: false,
            multipleContainersName: ['Cards', 'CardsNoFile', 'Accordeon', 'Slidecarousel'],
            allFiledsetContainerList: [],
            countermultiplecontainer: 1,
            cardsContainers: [],
            cardsNoFileContainers: [],
            accordeonContainers: [],
            slidecarouselContainers: [],
            htmlSectionCloneContent: ''

        }


    },
    created(){

        //Get All Media Data
        this.checkLocalStorage();

        //Set Data Page
        this.datainfo = JSON.parse(this.datapage);

        //Set Page Content
        this.alldata = JSON.parse(this.pagecontent);

        //Set textContent from Form Button
        this.formaction = Object.values(this.alldata).length > 0 ? 'update' : 'insert';

        //Set Btn Text
        this.btntext = Object.values(this.alldata).length === 0 ? 'Submit' : 'Update';

        //Set List of the Pre-default Elements
        this.predefaulthtmlelementslist = JSON.parse(this.predefaulthtmlelements);

        //Set List of the Section Elements
        this.sectionelementslist = JSON.parse(this.sectionelementsdescription);

        //Set Active Layout
        this.layoutactive = this.activelayout;

    },
    mounted(){

        //Render Pages Content
        this.renderData(this.alldata, 'init');

        //Att Data for Preview Routine
        this.previewRoutine('previewinit');

    },
    methods:{

        groupContainer(){

            //Get All fieldsets
            let allFieldsets = [...this.$refs.fieldsetbase.children];

            //Preserve Container List Data
            this.allFiledsetContainerList = allFieldsets;

            //All Multple Container
            let containerInfoList = [
                this.cardsContainers, 
                this.cardsNoFileContainers,
                this.accordeonContainers,
                this.slidecarouselContainers
            ];

            //Get All Container Names
            allFieldsets.forEach((value, index) => {

                //Get Legends Name
                let containerData = [...value.firstChild.children];

                //Check type of element
                if(containerData[0].nodeName === 'LEGEND'){
                    
                    //Set Container Info
                    let containerInfo = {
                        containername: containerData[0].textContent.trim(),
                        containerindex: index,
                        containerindexprev: index - 1,
                        containerindexnext: index + 1,
                        containerelement: value,
                        container_contentid: value.getAttribute('data-contentid')
                    };

                    //Set Container by Reference
                    switch(containerInfo.containername){

                        //Cards
                        case 'Cards':

                            //Push Container Data
                            this.cardsContainers.push(containerInfo);

                            //Remove Container
                            value.remove();


                        break;

                        //CardsNoFile
                        case 'CardsNoFile':

                            //Push Container Data
                            this.cardsNoFileContainers.push(containerInfo);

                            //Remove Container
                            value.remove();

                        break;

                        //Accordeon
                        case 'Accordeon':

                            //Push Container Data
                            this.accordeonContainers.push(containerInfo);

                            //Remove Container
                            value.remove();

                        break;

                        //Accordeon
                        case 'Slidecarousel':

                            //Push Container Data
                            this.slidecarouselContainers.push(containerInfo);

                            //Remove Container
                            value.remove();

                        break;


                    }

                }

            });

            //Create Html Element for Multiples Container
            this.groupContainerElementStructure(containerInfoList, allFieldsets);

        },
        groupContainerByLegend(element){

            //Get Parent Element
            let fieldset = element.target.parentElement.parentElement;

            //Check Element
            if(element.target.nodeName === 'LEGEND' && 
            this.multipleContainersName.includes(element.target.textContent.trim()) &&
            fieldset.getAttribute('data-multiple') === 'false'){

                //Get All fieldsets
                let allFieldsets = [...this.$refs.fieldsetbase.children];

                //Get Fieldset Container index
                let containerIndex = allFieldsets.indexOf(fieldset);

                //Set Container Info
                let containerInfo = {
                    containername: element.target.textContent.trim(),
                    containerindex: containerIndex,
                    containerindexprev: containerIndex - 1,
                    containerindexnext: containerIndex + 1,
                    containerelement: fieldset,
                    container_contentid: element.target.getAttribute('data-contentid')
                };

                //Remove Container
                fieldset.remove();

                //Remove Container from list
                allFieldsets.splice(containerIndex, 1);

                //console.log(allFieldsets);

                //Set Container by Reference
                switch(element.target.textContent.trim()){

                    //Cards
                    case 'Cards':

                        //Check length
                        if(this.cardsContainers.length > 0){

                            //Dynamic Add Container to Group Container
                            this.groupStructureContainerByLegend(allFieldsets, element.target.textContent.trim(), this.cardsContainers, containerInfo, fieldset);

                            //Push Container Data
                            this.cardsContainers.push(containerInfo);

                        }else{

                            //Push Container Data
                            this.cardsContainers.push(containerInfo);

                            //Create Html Element for Multiples Container
                            this.groupMultipleContainerElement(this.cardsContainers, allFieldsets);

                        }

                    break;

                    //CardsNoFile
                    case 'CardsNoFile':

                        //Check length
                        if(this.cardsNoFileContainers.length > 0){

                            //Dynamic Add Container to Group Container
                            this.groupStructureContainerByLegend(allFieldsets, element.target.textContent.trim(), this.cardsNoFileContainers, containerInfo, fieldset);

                            //Push Container Data
                            this.cardsNoFileContainers.push(containerInfo);

                        }else{

                            //Push Container Data
                            this.cardsNoFileContainers.push(containerInfo);

                            //Create Html Element for Multiples Container
                            this.groupMultipleContainerElement(this.cardsNoFileContainers, allFieldsets);

                        }

                    break;

                    //Accordeon
                    case 'Accordeon':

                        //Check length
                        if(this.accordeonContainers.length > 0){

                            //Dynamic Add Container to Group Container
                            this.groupStructureContainerByLegend(allFieldsets, element.target.textContent.trim(), this.accordeonContainers, containerInfo, fieldset);

                            //Push Container Data
                            this.accordeonContainers.push(containerInfo);

                        }else{

                            //Push Container Data
                            this.accordeonContainers.push(containerInfo);

                            //Create Html Element for Multiples Container
                            this.groupMultipleContainerElement(this.accordeonContainers, allFieldsets);

                        }

                    break;

                    //Accordeon
                    case 'Slidecarousel':

                        //Check length
                        if(this.slidecarouselContainers.length > 0){

                            //Dynamic Add Container to Group Container
                            this.groupStructureContainerByLegend(allFieldsets, element.target.textContent.trim(), this.slidecarouselContainers, containerInfo, fieldset);

                            //Push Container Data
                            this.slidecarouselContainers.push(containerInfo);

                        }else{

                            //Push Container Data
                            this.slidecarouselContainers.push(containerInfo);

                            //Create Html Element for Multiples Container
                            this.groupMultipleContainerElement(this.slidecarouselContainers, allFieldsets);

                        }

                    break;


                }

            }

        },
        groupContainerElementStructure(groupList, allFieldsets){

            //Create Html Element for Multiples Container
            groupList.forEach((value) => {

                //Check Container
                this.groupMultipleContainerElement(value, allFieldsets);

            });

        },
        groupStructureContainerByLegend(allFieldsets, legendName, multipleContainerList, containerInfo, fieldset){

            //Get Fieldset Group Position
            let groupListContainer = allFieldsets.find((value) => {

                //Check FirstChild Dom Element
                if(value.firstChild.children){

                    let accordeonDiv = [...value.firstChild.children];

                    if(accordeonDiv[0].nodeName === 'LEGEND' && 
                    accordeonDiv[0].textContent.trim().includes(legendName)
                    ){

                        return value;

                    }

                }

            });

            //Check data from groupListContainer
            if(groupListContainer === undefined){

                return;

            }

            //Get the Last Container of the Group
            let lastContainer = multipleContainerList.length === 1 ? multipleContainerList[0] : multipleContainerList[(multipleContainerList.length - 1)];

            //Get the Order Element Data
            let orderElementValue = lastContainer.containerelement.firstChild.querySelector('.activeorderbase .orderbase .ordercontent').textContent.trim();

            //Add Class for new style of fielset in group
            fieldset.classList.add('w-100');
            fieldset.classList.add('my-3');

            //Set Order for New Fieldset Element
            fieldset.firstChild.querySelector('.activeorderbase .orderbase .ordercontent').textContent = parseInt(orderElementValue) + 1;

            //Get DivBase
            let divGroupBase = groupListContainer.querySelector('.divgroupbase');

            //Set Multiple Conditional
            containerInfo.containerelement.setAttribute('data-multiple', true);

            //Get the Last index from all Containers List
            let lastContainerIndex = allFieldsets.lastIndexOf(groupListContainer);

            //Set Dynamic Value for New Order
            let newOrderValue = 1;

            //Att Order with new sequence
            allFieldsets.forEach((value, index) => {

                //Only Att Position bigger than Last Index Reference
                if(index > lastContainerIndex){

                    //Set Order for New Fieldset Element
                    value.querySelector('.activeorderbase .orderbase .ordercontent').textContent = (parseInt(orderElementValue) + 1) + newOrderValue;

                    //Increment New Order Value
                    newOrderValue++;

                }

            });

            //Append Child Container to Group Container
            divGroupBase.appendChild(containerInfo.containerelement);

        },
        groupMultipleContainerElement(groupContainer, allFieldsets){

            //Check Container
            if(groupContainer.length > 0){

                //Get Primary Position for create the Father Element
                let referencePosition = groupContainer[0].containerindexprev;

                //Get Reference Data from Primary Position
                let referenceElement = allFieldsets[referencePosition] ? allFieldsets[referencePosition] : this.$refs.fieldsetbase;

                //Reference Multiple Container classname
                let className = `multiple_container_${groupContainer[0].containername.toLowerCase()}_${this.countermultiplecontainer}`;

                //Content Fieldset 
                let divbase = htmlElements.createElement('fieldset',  {
                    class: `fieldset-pagescontent fieldset-multiple ${className}`,
                    data_contentorder: groupContainer[0].containerindex + 1,
                });

                //Append Element after Reference Position
                if(!referenceElement.classList.contains('fieldsetbase')){

                    referenceElement.after(divbase);

                }else{

                    referenceElement.appendChild(divbase);

                }


                //Accordeon Base | Legend - First Children for DivBase 
                let divacordeon = htmlElements.createElement('div',  {
                    class: `divaccordeon order-1 d-flex flex-row justify-content-between align-items-center divaccordeon_${className}`,
                });

                //Append Accordeon Base | Legend in DivBase
                document.querySelector(`.${className}`).appendChild(divacordeon);

                //Legend - First Children for Accordeon Base | Legend
                let legend = htmlElements.createElement('legend',  {
                    class: `mb-3 order-1 legendcontent_${className} legend-multiple`,
                    id: `legendcontent_${className}`,
                    aria_describedby: 'Multiple Container Group',
                    data_value: 'contentname',
                    contenteditable: false
                }, `${groupContainer[0].containername} Group`);

                //Append Legend in Accordeon Base | Legend
                document.querySelector(`.divaccordeon_${className}`).appendChild(legend);

                //Button Acordeon - Second Children for Accordeon Base | Legend
                let btnacordeon = htmlElements.createElement('button',  {
                    class: `order-1 btn btn-secondary btnaccordeon_${className}`,
                    type: 'button',
                    data_value: 'accordeongroup',
                    style: 'margin-right:.25rem;'
                }, 'Show');

                //Append Button Acordeon in Accordeon Base | Legend
                document.querySelector(`.divaccordeon_${className}`).appendChild(btnacordeon);

                //Div OrderBase - Second Children for Div ActiveOrder
                let divorderbase = htmlElements.createElement('div',  {
                    class: `d-flex flex-column ms-2 order-2 orderbase orderbase_${className}`,
                });

                //Append Div OrderBase in ActiveOrder
                document.querySelector(`.divaccordeon_${className}`).appendChild(divorderbase);

                //Span Order - First Children for Div OrderBase
                let spanorder = htmlElements.createElement('span',  {
                    class: `order-1`,
                }, 'Total');

                //Append Span Order in Div OrderBase
                document.querySelector(`.orderbase_${className}`).appendChild(spanorder);

                //Span OrderContent - Second Children for Div OrderBase
                let spanordercontent = htmlElements.createElement('span',  {
                    class:"order-2 multiple_total",
                    style:"font-weight:bolder;border: .1px solid #333;padding: .3rem;text-align: center;",
                    contenteditable:"false"
                }, `${groupContainer.length}`);

                //Append Span OrderContent in Div OrderBase
                document.querySelector(`.orderbase_${className}`).appendChild(spanordercontent);

                //Actions Buttons - Second Children for BTN Action Section Create 
                let divactionbuttons = htmlElements.createElement('div',  {
                    class: `d-none flex-column justify-content-center align-items-center order-2 mb-3 divgroupbase btnsectioncreate_${className}`,
                });

                //Append Actions Buttons in BTN Action Section Create
                document.querySelector(`.${className}`).appendChild(divactionbuttons);

                //Add Container for the Group
                groupContainer.forEach((valcontainer) => {

                    //Set Multiple Conditional
                    valcontainer.containerelement.setAttribute('data-multiple', true);

                    //Add Class to style element
                    valcontainer.containerelement.classList.add('w-100');
                    valcontainer.containerelement.classList.add('my-3');

                    //Append Actions Buttons in BTN Action Section Create
                    document.querySelector(`.btnsectioncreate_${className}`).appendChild(valcontainer.containerelement);

                });

                //Increment Value
                this.countermultiplecontainer++;

            }

        },
        previewRoutine(checkroutine){

            //Set Preview Routine
            this.formaction = checkroutine;

            //Get Page Content
            this.sendData();

        },
        checkLocalStorage(){

            //Set All Media
            this.allmediafileslocalstorage = localStorage.getItem('medialist');

            //Check Allmedia Files LocalStorage
            if(this.allmediafileslocalstorage){

                this.allmediafiles = JSON.parse(this.allmediafileslocalstorage);

            }

            return this.allmediafiles;

        },
        chooseImageFiledata(element){

            //console.log(this.filedataform);

            //Get Filedata from select image
            let filedata = {
                name: 'filesection',
                imageid: element.target.getAttribute('data-fileid'),
                filealt: element.target.getAttribute('data-filealt'), 
                fileext: element.target.getAttribute('data-fileext'), 
                filenamenew: element.target.getAttribute('data-filenamenew'), 
                filenameold: element.target.getAttribute('data-filenameold')
            };

            //Disabled Filesection Inputs findByNodeName
            let inputfiledivbase = [...document.getElementById(`${this.filedataform.baseinputid}`).children];

            //console.log(inputfiledivbase);

            //Get input FileAlt and set readonly
            let inputFileAlt = this.findByNodeName([...inputfiledivbase[0].children], 'INPUT');
            inputFileAlt.setAttribute('readonly', true);

            //Get input File and set disabled
            let inputFile = this.findByNodeName([...inputfiledivbase[1].children], 'INPUT');
            inputFile.setAttribute('disabled', true);

            //Get Next Element
            let nextSibling = inputFile.nextElementSibling;

            //Image Element - Create Element
            let image = htmlElements.createElement('img',  {
                class: 'image-input',
                data_filenameold: filedata.filenameold,
                data_filenamenew: filedata.filenamenew,
                data_filealt: filedata.filealt,
                alt: filedata.filealt,
                width: '190',
                height: '90',
                src: element.target.getAttribute('data-thumb') === 'true' ? `${this.imagestoragepath}/${filedata.imageid}/thumb_${filedata.filenamenew}` : element.target.getAttribute('src')
            });

            //Check Element to search img tag
            if(nextSibling === null){

                //Set Image Element related 
                inputFile.after(image);

            }else{

                //Check Img Tag
                if(nextSibling.nodeName === 'IMG'){

                    //Remove Old Element Tag and Create new one
                    nextSibling.remove();

                    //Set Image Element related 
                    inputFile.after(image);

                }

            } 

            //Get InputHtml Base
            let inputHtmlBase = document.getElementById(`${this.filedataform.baseinputid}`).nextElementSibling;

            //Get input html and set readonly
            let inputHtml = this.findByNodeName([...inputHtmlBase.children], 'INPUT');
            inputHtml.setAttribute('readonly', true);

            //Set Relation with sectionid and image filedata
            Object.assign(this.filedataform, filedata);

            //Push Filedataform
            this.filedataformlist.push(this.filedataform);

            //Push Filedataform to Preview
            this.filedataformlistpreview.push(this.filedataform);

            //Clean Filedata
            this.filedataform = {};

        },
        chooseImage(element){

            //List All Images
          /*   let mediaImageList = [...document.querySelectorAll('.media-image')];
                        
            //Remove class
            mediaImageList.forEach((valimg) => {

                //Check Active Class
                if(valimg.getAttribute('data-fileid') !== this.filedataform.inputid &&
                valimg.classList.contains('select-image')){

                    valimg.classList.remove('select-image');

                }

            }); */

            //Add Class 
            //element.target.classList.add('select-image');

            //Check InputId for Push
            if(this.filedataformlist.length > 0){

                //Find FileSelect
                let selectfile = this.filedataformlist.find((valfile) => {

                    if(valfile.hasOwnProperty('fileaction') && valfile.referimgselectbyinput === this.filedataform.referimgselectbyinput){

                        return valfile;

                    }

                });

                /* console.log(selectfile);
                console.log(this.filedataformlist); */
                /* console.log(this.filedataformlist);
                console.log(this.filedataform.inputid); */

                //Check select image filedata
                if(selectfile === undefined){

                    //Add Class 
                    //element.target.classList.add('select-image');

                    //Set Fileformdata from select image
                    this.chooseImageFiledata(element);

                }else{

                    //A imagem já foi selecionada
                    //alert(`A imagem já foi selecionada para a section ${this.filedataform.baseinputid}`);

                    //Confirm New Image for Section
                    let changeSelectImage = confirm('A imagem já foi selecionada para a section. Deseja a substituir ?');

                    //Check Response
                    if(changeSelectImage){

                        //Get index select image
                        let indexSelect = this.filedataformlist.indexOf(selectfile);

                        //Remove select image
                        this.filedataformlist.splice(indexSelect, 1);

                        //Remove select image from Preview List
                        this.filedataformlistpreview.splice(indexSelect, 1);

                        //Set Fileformdata from select image
                        this.chooseImageFiledata(element);

                    }
                    
                }

            }else{

                //Add Class 
                //element.target.classList.add('select-image');

                //Set Fileformdata from select image
                this.chooseImageFiledata(element);

            }

            //console.log(this.filedataformlist);
            console.log(this.filedataformlist);

            //Enabled Button
            this.disabled = false;

            //Closed Model
            this.hideModal('baseselectimage');

        },
        showModal(element, classname){

            //console.log(element);

            //Get Filedata from select image
            this.filedataform = {
                baseinputid: element.getAttribute('data-baseinputid'),
                inputid: element.getAttribute('data-inputid'),
                referimgselectbyinput: element.getAttribute('data-referimgselectbyinput'),
                fileaction: 'select'
            };

            //Show Modal
            $(`.${classname}`).modal("show");

            return;

        },
        onlyShowModal(classname){

            //Show Modal
            $(`.${classname}`).modal("show");

            return;

        },
        hideModal(classname){

            //Hide Modal
            $(`.${classname}`).modal("hide");

        },
        showBox(element){

            //Check Element
            if(document.querySelector(`.${element}`).classList.contains('d-none')){

                //Remove Class
                document.querySelector(`.${element}`).classList.remove('d-none');

                return;

            }

            //Add Class
            document.querySelector(`.${element}`).classList.add('d-none');

            return;

        },
        renderData(alldata, contentidreferindicate = 'init'){

            //Check for Old Page Content
            if(Object.values(alldata).length > 0){

                //Set Indicate Order to 0
                this.ordercontentdefault = 0;

                //Search for children
                [...this.$refs.fieldsetbase.children].forEach((value) => {

                    //Remove Default Fieldset
                    value.remove();


                });

                //console.log(Object.values(this.alldata));

                //Set Old Values for Update
                Object.values(alldata).forEach((value, index) => {
                
                    //Check Content Data
                    if(Object.values(JSON.parse(value.content_data)).length > 0){

                        //Set Content Order
                        let orderItemData = {
                            content_id: parseInt(value.content_id),
                            order_content: parseInt(value.order_content)
                        };

                        //Push Order Content
                        this.orderbaselistoriginal.push(orderItemData);

                        //Get Data From Content Data
                        let content_data = Object.values(JSON.parse(value.content_data));

                        //Set FiledSet Counter
                        this.counterfieldset = value.content_id;

                        //console.log(content_data);

                        //Set Contents Ids refer by Pages
                        switch(contentidreferindicate){

                            //Start Content
                            case 'init':

                                this.contentidrefer.push(value.content_id);
                                this.contentidreferpreview.push(value.content_id);

                            break;

                            //Page Content only
                            case 'pagecontent':

                                this.contentidrefer.push(value.content_id);
                             
                            break;
                            
                            //Page Preview only
                            case 'pagepreview':

                                this.contentidreferpreview.push(value.content_id);
                             
                            break; 

                        }
                        
                        //Create Fieldset Content
                        this.addFieldsetContent(
                            'fieldsetbase',
                            false, 
                            value.container_name,
                            value.content_id,
                            value.order_content,
                            content_data[0].contentclassrefer,
                            parseInt(value.active_content)
                        );

                        //Check for Input Sections
                        content_data[1].forEach((valsection, indexsection) => {

                            //console.log(valsection);

                            //Counter Update Section
                            let counterUpdateSection = 1;

                            //Increment new value
                            counterUpdateSection++;

                            //Set Random Number
                            this.randomInputNumberGenerate();

                            //Check Section Type
                            switch(valsection.sectiontype){

                                //Titlesection Update
                                case 'titlesection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 1));

                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`, 
                                        `inputtitlegroup${counterUpdateSection}`,
                                        'titlesection',
                                        `${valsection.sectionname}`, 
                                        `titleinputall_${counterUpdateSection}_${this.randomInputNum}`, 
                                        'titleinput', 
                                        'Title', 
                                        'Please inform the title',
                                        false,
                                        'text',
                                        `${valsection.sectionvalue[0]}`,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.countertitleinput = counterUpdateSection;

                                break;

                                //Subtitle Update
                                case 'subtitlesection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 2));

                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`, 
                                        `inputsubtitlegroup${counterUpdateSection}`, 
                                        'subtitlesection',
                                        `${valsection.sectionname}`, 
                                        `subtitleinputall_${counterUpdateSection}__${this.randomInputNum}`, 
                                        'subtitleinput', 
                                        'Subtitle', 
                                        'Please inform the subtitle',
                                        false,
                                        'text',
                                        `${valsection.sectionvalue[0]}`,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.countersubtitleinput = counterUpdateSection;

                                break;

                                //Classname Update
                                case 'classsection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 3));

                                    //Execute the Method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`,  
                                        `inputclassnamegroup${counterUpdateSection}`,  
                                        'classsection',
                                        `${valsection.sectionname}`, 
                                        `classnameinputall_${counterUpdateSection}_${this.randomInputNum}`, 
                                        'classnameinput', 
                                        'Classname', 
                                        'Please inform the classname',
                                        false,
                                        'text',
                                        `${valsection.sectionvalue[0]}`,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.counterclassinput = counterUpdateSection;

                                break;

                                //Description Update
                                case 'descriptionsection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 4));

                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`,  
                                        `textareagroup${counterUpdateSection}`,    
                                        'descriptionsection',
                                        `${valsection.sectionname}`,  
                                        `textareainputall_${counterUpdateSection}_${this.randomInputNum}`, 
                                        'textareainput', 
                                        'Description', 
                                        'Please inform the description',
                                        false,
                                        'textarea',
                                        `${valsection.sectionvalue[0]}`,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.counterdescriptioninput = counterUpdateSection;

                                break;

                                //Description Update
                                case 'htmlsection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 4));

                                    //textarea, htmlvalue
                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`,  
                                        `htmlgroup${counterUpdateSection}`,    
                                        'htmlsection',
                                        `${valsection.sectionname}`,  
                                        `htmlinputall_${counterUpdateSection}_${this.randomInputNum}`, 
                                        'htmlinput', 
                                        'Html', 
                                        'Please inform the html',
                                        false,
                                        'htmlvalue',
                                        `${valsection.sectionvalue[0]}`,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.counterhtmlinput = counterUpdateSection;

                                break;

                                //CTA Update
                                case 'ctasection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 5));
                                    
                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`,  
                                        `inputctagroup${counterUpdateSection}`, 
                                        'ctasection',
                                        `${valsection.sectionname}`, 
                                        `ctainputall_${counterUpdateSection}_${this.randomInputNum}`, 
                                        'ctainput', 
                                        'CTA', 
                                        'Please inform the cta',
                                        false,
                                        'text',
                                        valsection.sectionvalue,
                                        valsection.sectionhtmlelement,
                                        counterUpdateSection
                                    );

                                    //Set New Value for Counter
                                    this.counterctainput = counterUpdateSection;
                                
                                break;

                                //File Update
                                case 'filesection':

                                    //Sum Index
                                    counterUpdateSection = (counterUpdateSection + (indexsection + 6));

                                    //Set New Value for File Counter
                                    let inputidrefer = parseInt(valsection.sectionfileinputid.replace('file_', ''));
                                    //let inputidrefer = counterUpdateSection;
                                    this.counterfileinput = inputidrefer;

                                    //Image list
                                    let imageList = value.image_id || value.image_id !== null ? JSON.parse(value.image_id) : [];

                                    //console.log(imageList);

                                    //Set Image id
                                    valsection.sectionvalue.imageid = imageList[this.imageIdCounter] ? imageList[this.imageIdCounter] : parseInt(imageList.join(""));

                                    //console.log(valsection);

                                    //Set File Data for Update
                                    this.filedataformupdatelist.push(valsection);

                                    //Set File Data for Preview
                                    this.filedataformupdatelistpreview.push(valsection);

                                    //Check Section value Type
                                    let sectionValue = Array.isArray(this.filedataformupdatelist[this.imageIdCounter].sectionvalue) 
                                    ? this.filedataformupdatelist[this.imageIdCounter].sectionvalue[1] : this.filedataformupdatelist[this.imageIdCounter].sectionvalue;

                                    //console.log(valsection.sectionvalue);
                                    //console.log(sectionValue);
                                    //console.log(this.imageIdCounter);

                                    //Check sectionValue for Array
                                    sectionValue = Array.isArray(sectionValue) ? sectionValue[1] : sectionValue;

                                    //console.log(sectionValue);

                                    //Execute the method
                                    this.addSectionDeploy(
                                        `.inputbase${value.content_id}`,  
                                        `inputfilegroup${counterUpdateSection}`, 
                                        'filesection',
                                        `${valsection.sectionname}`, 
                                        `fileinputall_${counterUpdateSection}_${this.counterfieldset}`, 
                                        'fileinput', 
                                        'File Info', 
                                        'Please inform the alt from file',
                                        false,
                                        'file',
                                        `${sectionValue.filealt}`,
                                        valsection.sectionhtmlelement,
                                        sectionValue,
                                        counterUpdateSection,
                                        inputidrefer
                                    );

                                    //Increments
                                    this.imageIdCounter++;

                                break;

                            }

                        });

                    }

                });

                //Return imageIdCounter for the original value
                this.imageIdCounter = 0;

                //Group Multiple Containers
                this.groupContainer();

            }

            //console.log(this.filedataformupdatelist);

            return;

        },
        actionButtons(element){

            //Get Element
            let el = element.target;

            //Check element
            if(el.nodeName === 'BUTTON'){

                //Check if the attribute exist
                if(el.hasAttribute('data-value')){

                    //Set Random Number
                    this.randomInputNumberGenerate();

                    //console.log(el);

                    //Get Button Action
                    switch(el.getAttribute('data-value')){

                        //Active Content
                        case 'activecontent':

                            //Execute the Method
                            this.activeContent(el);

                        break;

                        //Accordeon Method
                        case 'accordeon':
                        case 'accordeonsection':
                        case 'accordeongroup':         

                            //Execute the Method
                            this.acoordeanMethod(el, el.getAttribute('data-value'));

                        break;

                        //Classname Section Create
                        case 'classsection':

                            //Check Sections by Container
                            let confirmSection = this.checkSectionsPerContainer(el.getAttribute('data-value'), el);

                            //Conditional for Create
                            if(confirmSection === undefined){

                                //Execute the Method
                                this.addSectionDeploy(
                                    `.${el.getAttribute('data-inputbase')}`, 
                                    `inputclassnamegroup_${this.countersection}__${this.counterfieldset}`, 
                                    'classsection',
                                    'Classname Parent Section', 
                                    `classnameinputall_${this.countersection}__${this.counterfieldset}`, 
                                    `classnameinput__${this.countersection}__${this.counterfieldset}_`, 
                                    'Classname', 
                                    'Please inform the classname',
                                    false,
                                    'text'
                                );

                            }else{

                                //Show Message
                                alert("Favor apenas criar uma Classname Section por Bloco");

                            }

                        break;

                        //Title Section Create
                        case 'titlesection':

                            //Execute the method
                            this.addSectionDeploy(
                                `.${el.getAttribute('data-inputbase')}`, 
                                `inputtitlegroup_${this.countersection}__${this.counterfieldset}`, 
                                'titlesection',
                                'Title Section', 
                                `titleinputall_${this.countersection}__${this.counterfieldset}`, 
                                `titleinput__${this.countersection}__${this.counterfieldset}_`, 
                                'Title', 
                                'Please inform the title',
                                false,
                                'text'
                            );

                        break;

                        //Subtitle Section Create
                        case 'subtitlesection':

                            //Execute the method
                            this.addSectionDeploy(
                                `.${el.getAttribute('data-inputbase')}`, 
                                `inputsubtitlegroup_${this.countersection}__${this.counterfieldset}`, 
                                'subtitlesection',
                                'Subtitle Section', 
                                `subtitleinputall_${this.countersection}__${this.counterfieldset}`, 
                                `subtitleinput__${this.countersection}__${this.counterfieldset}_`, 
                                'Subtitle', 
                                'Please inform the subtitle',
                                false,
                                'text'
                            );

                        break;

                        //File Section Create
                        case 'filesection':

                            //Check Sections by Container
                            let confirmSectionfile = this.checkSectionsPerContainer(el.getAttribute('data-value'), el);

                            //Conditional for Create
                            if(confirmSectionfile === undefined){

                                //Execute the method
                                this.addSectionDeploy(
                                    `.${el.getAttribute('data-inputbase')}`, 
                                    `inputfilegroup_${this.countersection}__${this.counterfieldset}`, 
                                    'filesection',
                                    'File Section', 
                                    `fileinputall_${this.countersection}__${this.counterfieldset}`, 
                                    `fileinput__${this.countersection}__${this.counterfieldset}_`, 
                                    'File Info', 
                                    'Please inform the alt from file',
                                    false,
                                    'file',
                                    '',
                                    'img',
                                    {},
                                    0,
                                    this.counterfileinput
                                );

                            }else{

                                //Show Message
                                alert("Favor apenas criar um File Section por Bloco");

                            }    

                        break;

                        //Description Section Create
                        case 'descriptionsection':

                            //Execute the method
                            this.addSectionDeploy(
                                `.${el.getAttribute('data-inputbase')}`, 
                                `textareagroup_${this.countersection}__${this.counterfieldset}`, 
                                'descriptionsection',
                                'Description Section', 
                                `textareainputall_${this.countersection}__${this.counterfieldset}`, 
                                `textareainput__${this.countersection}__${this.counterfieldset}_`, 
                                'Description', 
                                'Please inform the description',
                                false,
                                'textarea'
                            );

                        break;

                        //HTML Section Create
                        case 'htmlsection':

                            //Check Sections by Container
                            let confirmSectionhtml = this.checkSectionsPerContainer(el.getAttribute('data-value'), el);

                            //Conditional for Create
                            if(confirmSectionhtml === undefined){

                                //Execute the method - textarea
                                this.addSectionDeploy(
                                    `.${el.getAttribute('data-inputbase')}`, 
                                    `htmlgroup_${this.countersection}__${this.counterfieldset}`, 
                                    'htmlsection',
                                    'HTML Section', 
                                    `htmlinputall_${this.countersection}__${this.counterfieldset}`, 
                                    `htmlinput__${this.countersection}__${this.counterfieldset}_`, 
                                    'Html', 
                                    'Please inform the html',
                                    false,
                                    'htmlvalue',
                                );

                            }else{

                                //Show Message
                                alert("Favor apenas criar uma HTML Section por Bloco");

                            }

                        break;

                        //Remove Section
                        case 'removesection':
                        case 'removecontent':    

                            //Execute the method
                            this.removeMethod(el, el.getAttribute('data-value'));

                        break;

                        //CTA Section Creat
                        case 'ctasection':
                            
                            //Execute the method
                            this.addSectionDeploy(
                                `.${el.getAttribute('data-inputbase')}`, 
                                `inputctagroup_${this.countersection}__${this.counterfieldset}`, 
                                'ctasection',
                                'CTA Section', 
                                `ctainputall_${this.countersection}__${this.counterfieldset}`, 
                                `ctainput__${this.countersection}__${this.counterfieldset}_`, 
                                'CTA', 
                                'Please inform the cta',
                                false,
                                'text'
                            );
                        
                        break;

                        //Select Images
                        case 'selectfile':

                            //Show Modal
                            this.showModal(el, 'baseselectimage');

                        break;

                    }

                    return;

                } 

            }

            return;

        },
        checkSectionsPerContainer(typesection, element){

            //Get Section divs from InputBase
            let inputBaseChildrens = [...document.querySelector(`.${element.getAttribute('data-inputbase')}`).children];

            //Check Children
            let confirmSection = inputBaseChildrens.find((value) => {

                if(value.hasAttribute('data-value') && value.getAttribute('data-value') === typesection){

                    return value;

                }

            });

            return confirmSection;

        },
        activeContent(element){

            //Get Content Id
            let contentid = element.getAttribute('data-contentid');

            //Active routine
            let activeRoutine = 'active';

            //Confirm Preview Conditional
            let confirmPreview = false;

            //Confirm Active Content
            let confirmContent = false;

            //Only Execute Method when pre-exist Container
            if(Object.values(this.alldata).length > 0 && element.getAttribute('data-actionactive') === 'update'){

                //Confirm Preview Conditional
                confirmPreview = confirm('Active or Desactive this content for Preview ?');

                //Get Parent Element
                let parentActiveEl = element.parentElement;

                //Send Active Value
                let activeValue = element.textContent;

                //Active routine
                activeRoutine = confirmPreview ? 'previewactive' : activeRoutine;

                //Change Background when the content is for preview
                if(confirmPreview){

                    //Set ActivePreview Routine
                    this.previwActiveRoutine = true;

                    //Only add Class when is the first change
                    if(!parentActiveEl.classList.contains('previewactive') && !parentActiveEl.classList.contains('previewdesactive')){

                        //Preview Routine Logic
                        activeValue = element.textContent === 'Yes' ? 'No' : 'Yes';

                        switch(activeValue){

                            //Active
                            case 'Yes':

                                parentActiveEl.classList.add('previewactive');

                            break;

                            //Desactive
                            case 'No':

                                parentActiveEl.classList.add('previewdesactive');

                            break;

                        }

                    }else{

                        //Check Active or Desactive class for Review Sequence
                        if(parentActiveEl.classList.contains('previewdesactive')){

                            //Set Class
                            parentActiveEl.classList.remove('previewdesactive');
                            parentActiveEl.classList.add('previewactive');

                            //Set Active Value
                            activeValue = 'Yes';

                        }else{

                            //Set Class
                            parentActiveEl.classList.remove('previewactive');
                            parentActiveEl.classList.add('previewdesactive');

                            //Set Active Value
                            activeValue = 'No';

                        }

                    }

                    //Remove Container from Table
                    this.sendDataActions(contentid, activeRoutine, activeValue);

                }else{

                    //Confirm Active Content
                    confirmContent = confirm('Active or Desactive this content for Website ?');
                    
                    //Send Active Request
                    if(confirmContent){

                        //Remove Container from Table
                        this.sendDataActions(contentid, activeRoutine, activeValue);

                    }

                }

            }

            //Set Active Conditional
            let textContentButton = element.textContent;

            //Only Change Value when is not for preview routine
            if(activeRoutine === 'active' && !confirmPreview && confirmContent){

                element.textContent = textContentButton === 'Yes' ? 'No' : 'Yes';

            }
            
        },
        orderContent(){

            //Set Disabled
            document.querySelector('.orderbtn').setAttribute('disabled', true);

            //Get All Data from Order Content
            let orderContentList = [...document.querySelectorAll('.ordercontent')];

            //Check Data
            let checkValue = [];

            //Get Data from Order Sequence
            orderContentList.forEach((value) => {

                //Check Value
                checkValue.push(this.inputValidationMethod(2, value.textContent.trim()));

                //Set Content Order
                let orderItemData = {
                    content_id: parseInt(value.getAttribute('data-contentid')),
                    order_content: parseInt(value.textContent.trim())
                };

                //Push Order Content
                this.orderbaselist.push(orderItemData);

            });

            //Check Value from Input Order
            if(checkValue.includes(false)){

                //Send Message
                alert('Favor informar apenas números para Order');

                //Remove Disabled
                document.querySelector('.orderbtn').removeAttribute('disabled');

                //Clean Variable
                this.orderbaselist = [];

                return;

            }    

            //Data Structure
            let dataForm = {
                page_id: this.datainfo[0].id,
                contentlist: this.contentidrefer
            };

            //Set Order List
            dataForm.orderposition = this.orderbaselist;

            //Set Order Original Position
            dataForm.orderoriginalposition = this.orderbaselistoriginal;

            //Set Fetch Action
            return this.actionFetchStructure('order', dataForm);

        },
        acoordeanMethod(el, action){

            //Get div
            let div = action === 'accordeon' || action === 'accordeongroup' ? el.parentElement.nextElementSibling : el.parentElement.parentElement.nextElementSibling;

            //Check class
            if(div.classList.contains('d-none')){

                //Set Text Content
                el.textContent = 'Hide';

                //Remove Class
                div.classList.remove('d-none');

            }else{

                //Set Text Content
                el.textContent = 'Show';

                //Add Class
                div.classList.add('d-none');

            }

            return;

        },
        addFieldsetContent(
            appenddiv,
            disabledorder,
            legendvalue = '',
            contentid = '',
            ordercontent = '',
            classrefer = '',
            activecontent = 1
        ){

            //Disabled Order Button
            if(Object.values(this.alldata).length > 0 && disabledorder){

                //Set Disabled
                document.querySelector('.orderbtn').setAttribute('disabled', true);

            }

            //Set ActivePreview Routine
            this.previwActiveRoutine = false;

            //Increments
            this.counterfieldset++;

            //Increment Order Content Default Value
            this.ordercontentdefault++;

            //Check Content ID
            let contentId = contentid === '' ? `${this.counterfieldset}_${this.randomInputNum}` : contentid;
            //Check Order Content
            let orderContent = ordercontent === '' ? this.ordercontentdefault : ordercontent;
            //Check Active Content
            let activeContent = activecontent === 0 ? 'No' : 'Yes';
            //Check Active Action
            let acttiveAction = contentid === '' ? 'insert' : 'update';
            
            //Content Fieldset 
            let divbase = htmlElements.createElement('fieldset',  {
                class: `fieldset-pagescontent content${contentId}`,
                data_fieldset: contentId,
                data_contentorder: orderContent,
                data_contentid: contentId,
                data_multiple: false
            });

            //Append Divbase
            document.querySelector(`.${appenddiv}`).appendChild(divbase);

            //Accordeon Base | Legend - First Children for DivBase 
            let divacordeon = htmlElements.createElement('div',  {
                class: `divaccordeon d-flex flex-row justify-content-between align-items-center divaccordeon${contentId}`,
            });

            //Append Accordeon Base | Legend in DivBase
            document.querySelector(`.content${contentId}`).appendChild(divacordeon);

            //Legend - First Children for Accordeon Base | Legend
            let legend = htmlElements.createElement('legend',  {
                class: `mb-3 order-1 legendcontent${contentId}`,
                id: `legendcontent${contentId}`,
                aria_describedby: 'change content name',
                data_value: 'contentname',
                data_validation: 5,
                contenteditable: true
            }, legendvalue === '' ? 'Content' : legendvalue);

            //Append Legend in Accordeon Base | Legend
            document.querySelector(`.divaccordeon${contentId}`).appendChild(legend);

            //Remove Button - Second Children for Accordeon Base | Legend
            let removebtn = htmlElements.createElement('button',  {
                class: 'order-2 btn btn-danger removecontent',
                type: 'button',
                data_value: 'removecontent',
                data_actionremove: acttiveAction,
                style: 'margin-right:.25rem;'
            }, 'Remove');

            //Append Remove Button in Accordeon Base | Legend
            document.querySelector(`.divaccordeon${contentId}`).appendChild(removebtn);

            //Button Acordeon - Second Children for Accordeon Base | Legend
            let btnacordeon = htmlElements.createElement('button',  {
                class: `order-3 btn btn-secondary btnaccordeon${contentId}`,
                type: 'button',
                data_value: 'accordeon',
                style: 'margin-right:.25rem;'
            }, 'Show');

            //Append Button Acordeon in Accordeon Base | Legend
            document.querySelector(`.divaccordeon${contentId}`).appendChild(btnacordeon);

            //Div ActiveOrder - Third Children for Accordeon Base | Legend
            let divactiveorder = htmlElements.createElement('div',  {
                class: `d-flex flex-row order-4 activeorderbase activeorderbase${contentId}`,
                style: 'margin-bottom:1.1rem;margin-right:.25rem;'
            });

            //Append Div ActiveOrder in Accordeon Base | Legend
            document.querySelector(`.divaccordeon${contentId}`).appendChild(divactiveorder);

            //Div ActiveBase - First Children for Div ActiveOrder
            let divactivebase = htmlElements.createElement('div',  {
                class: `d-flex flex-column order-1 activebase activebase${contentId}`,
            });

            //Append Div ActiveBase in ActiveOrder
            document.querySelector(`.activeorderbase${contentId}`).appendChild(divactivebase);

            //Span Active - First Children for Div ActiveBase
            let spanactive = htmlElements.createElement('span',  {
                class: `order-1`,
            }, 'Active');

            //Append Span Active in Div ActiveBase
            document.querySelector(`.activebase${contentId}`).appendChild(spanactive);

            //Button Active - Second Children for Div ActiveBase
            let btnactive = htmlElements.createElement('button',  {
                type:"button", 
                class:"order-2 btn btn-light btnactive", 
                data_value:"activecontent",
                data_fieldset: contentId, 
                data_contentorder: orderContent,
                data_contentid: contentId,
                data_actionactive: acttiveAction,
            }, `${activeContent}`);

            //Append Button Active in Div ActiveBase
            document.querySelector(`.activebase${contentId}`).appendChild(btnactive);

            //Div OrderBase - Second Children for Div ActiveOrder
            let divorderbase = htmlElements.createElement('div',  {
                class: `d-flex flex-column order-2 orderbase orderbase${contentId}`,
            });

            //Append Div OrderBase in ActiveOrder
            document.querySelector(`.activeorderbase${contentId}`).appendChild(divorderbase);

            //Span Order - First Children for Div OrderBase
            let spanorder = htmlElements.createElement('span',  {
                class: `order-1`,
            }, 'Order');

            //Append Span Order in Div OrderBase
            document.querySelector(`.orderbase${contentId}`).appendChild(spanorder);

            //Span OrderContent - Second Children for Div OrderBase
            let spanordercontent = htmlElements.createElement('span',  {
                class:"order-2 ordercontent",
                data_fieldset: contentId, 
                data_contentorder: orderContent,
                data_contentid: contentId,
                style:"font-weight:bolder;border: .1px solid #333;padding: .3rem;text-align: center;",
                contenteditable:"true"
            }, `${orderContent}`);

            //Append Span OrderContent in Div OrderBase
            document.querySelector(`.orderbase${contentId}`).appendChild(spanordercontent);

            //Input Base Section - Second Children for DivBase d-none
            let divinputbasesection = htmlElements.createElement('div',  {
                class: `inputbase d-none inputbase${contentId}`,
            });

            //Append Input Base Section in DivBase
            document.querySelector(`.content${contentId}`).appendChild(divinputbasesection);

            //BTN Action Section Create - First Children for DivBase 
            let divbtnsectioncreate = htmlElements.createElement('div',  {
                class: `btnbasesectioncreate mb-3 d-flex flex-column justify-content-center align-items-center btnbasesectioncreate${contentId}`,
            });

            //Append BTN Action Section Create in DivBase
            document.querySelector(`.inputbase${contentId}`).appendChild(divbtnsectioncreate);

            //Span Title - First Children for BTN Action Section Create
            let spantitlesection = htmlElements.createElement('span',  {
                class: `titlebtnsectioncreate order-1 my-3 titlebtnsectioncreate${contentId}`,
            }, 'Create a Section');

            //Append Span Title in BTN Action Section Create
            document.querySelector(`.btnbasesectioncreate${contentId}`).appendChild(spantitlesection);

            //Actions Buttons - Second Children for BTN Action Section Create 
            let divactionbuttons = htmlElements.createElement('div',  {
                class: `d-flex flex-row justify-content-around align-items-center order-2 btnsectioncreate mb-3 btnsectioncreate${contentId}`,
            });

            //Append Actions Buttons in BTN Action Section Create
            document.querySelector(`.btnbasesectioncreate${contentId}`).appendChild(divactionbuttons);

            //Button Classname Create - First Children for BTN Action Section Create
            let btnclass = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'classsection',
                data_inputbase: `inputbase${contentId}`
            }, 'Classname');

            //Button Title Create - Second Children for BTN Action Section Create
            let btntitle = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'titlesection',
                data_inputbase: `inputbase${contentId}`
            }, 'Title');

            //Button Subtitle Create - Third Children for BTN Action Section Create
            let btnsubtitle = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'subtitlesection',
                data_inputbase: `inputbase${contentId}`
            }, 'Subtitle');

            //Button File Create - Fourth Children for BTN Action Section Create
            let btnfile = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'filesection',
                data_inputbase: `inputbase${contentId}`
            }, 'File');

            //Button Description Create - Fifty Children for BTN Action Section Create
            let btndescription = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'descriptionsection',
                data_inputbase: `inputbase${contentId}`
            }, 'Description');

            //Button CTA Create - Sixty Children for BTN Action Section Create
            let btncta = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'ctasection',
                data_inputbase: `inputbase${contentId}`
            }, 'CTA');

            //Button HTML Create - Seventy Children for BTN Action Section Create
            let btnhtml = htmlElements.createElement('button',  {
                class: `btn btn-dark`,
                type: 'button',
                data_value: 'htmlsection',
                data_inputbase: `inputbase${contentId}`
            }, 'HTML');

            //Append Button in Actions Buttons
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btnclass);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btntitle);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btnsubtitle);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btnfile);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btndescription);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btncta);
            document.querySelector(`.btnsectioncreate${contentId}`).appendChild(btnhtml);
            
            //Return Fieldset Content
            return divbase;

        },
        addSectionDeploy(
            appenddiv, 
            classname, 
            sectiontype,
            sectionname, 
            classbasename, 
            classdicchildrenname, 
            labelmessage, 
            placeholdermsg, 
            addbtninput = false, 
            inputype = 'text', 
            inputvalue = '',
            htmlelement = '',
            filedata = {},
            contentid = 0,
            inputidrefer = 0
        ){

            //Set ActivePreview Routine
            this.previwActiveRoutine = false;
            
            //Check Content ID
            let contentId = contentid !== 0 ? contentid : `${this.countersection}_${this.randomInputNum}`;
            let className = contentid !== 0 ? `${classname}_${contentId}_${this.counterfieldset}` : `${classname}_${this.randomInputNum}`;
            let sectionBase = `sectionbase_${classbasename}${contentId}__${this.counterfieldset}`;
            let baseActionsName = `basebtnactions_${classbasename}${contentId}__${this.counterfieldset}_${classdicchildrenname}`;

            //Check Active Action
            let acttiveAction = contentid === 0 ? 'insert' : 'update';

            //DIV inputbasesection
            let divbase = htmlElements.createElement('div',  {
                class: `inputbasesection mb-2 ${className}`,
                id: `${className}`,
                data_inputobaseorder: contentId,
                data_value: sectiontype
            });

            //Append Divbase
            document.querySelector(appenddiv).appendChild(divbase);

            //DIV First Children - Base BTNs for DivBase
            let divbtn = htmlElements.createElement('div',  {
                class: `sectionbase d-flex flex-row justify-content-between align-items-center ${sectionBase}`
            });

            //Append DivBtn | Section Base in DivBase
            document.querySelector(`.${className}`).appendChild(divbtn);

            //Strong Element - First Children DivBtn | Section Base
            let strong = htmlElements.createElement('strong',  {
                class: 'my-3 order-1 sectionname',
                id: `strong_${sectionBase}`,
                data_validation: 4,
                contenteditable: 'true'
            }, `${sectionname}`);

            //Append Strong in DivBtn | Section Base
            document.querySelector(`.${sectionBase}`).appendChild(strong);

            //BaseBtnAction Element - Second Children DivBtn | Section Base
            let basebtnactions = htmlElements.createElement('div',  {
                class: `basebtnactions d-flex flex-row order-2 justify-content-end ${baseActionsName}`,
                data_baseid: `${baseActionsName}`
            });

            //Append Strong in DivBtn | Section Base
            document.querySelector(`.${sectionBase}`).appendChild(basebtnactions);

           //Show|Hide Button for BaseBtnAction
           let addshowhide = htmlElements.createElement('button',  {
                class: 'btn btn-light btnaccordeonsection',
                type: 'button',
                data_section: sectiontype,
                data_inputtype: inputype,
                data_value: 'accordeonsection'
            }, 'Show');

            //Append Show|Hide Button in BaseBtnAction
            document.querySelector(`.${baseActionsName}`).appendChild(addshowhide);

            //Add Remove Button for BaseBtnAction
            let removebtn = htmlElements.createElement('button',  {
                class: 'btn btn-danger removeinput',
                type: 'button',
                data_section: sectiontype,
                data_inputtype: inputype,
                data_value: 'removesection',
                data_actionremove: acttiveAction
            }, 'Remove Section');

            //Append Add Input Button in BaseBtnAction
            document.querySelector(`.${baseActionsName}`).appendChild(removebtn);

            //DIV Second Children - All Inputs Div for DivBase
            let divallinputs = htmlElements.createElement('div',  {
                class: `${classbasename.replace(contentId, '')} my-3 ${classbasename} d-none`
            });

            //Append All Inputs Div in DivBase
            document.querySelector(`.${className}`).appendChild(divallinputs);

            //Set Param for Input Structure
            let counter = 1;
            let htmlelementvalue = htmlelement === '' ? 'div' : htmlelement;
            let validationtype = 4;
            let inputValueCTA = !Array.isArray(inputvalue) ? inputvalue : inputvalue[1];

            //Indicate Type of section for Counter
            switch(sectiontype){

                case 'classsection':

                    this.counterclassinput++;
                    counter = this.counterclassinput;
                    htmlelementvalue = htmlelement === '' ? 'div' : htmlelement;
                    validationtype = 4;

                break;

                case 'titlesection':

                    this.countertitleinput++;
                    counter = this.countertitleinput;
                    htmlelementvalue = htmlelement === '' ? 'h1' : htmlelement;
                    validationtype = 4;

                break;

                case 'subtitlesection':

                    this.countersubtitleinput++;
                    counter = this.countersubtitleinput;
                    htmlelementvalue = htmlelement === '' ? 'h2' : htmlelement;
                    validationtype = 4;

                break;

                case 'filesection':

                    //Check Input Id refer
                    counter = this.counterfileinput <= inputidrefer ? inputidrefer : this.counterfileinput;

                    //Select Image Button for BaseBtnAction
                    let addselectimage = htmlElements.createElement('button',  {
                        class: 'btn btn-secondary btnselectimage',
                        type: 'button',
                        data_section: sectiontype,
                        data_inputtype: inputype,
                        data_value: 'selectfile',
                        data_inputid: `file_${counter}`,
                        data_referimgselectbyinput: `file_${counter}_${baseActionsName}`,
                        data_baseinputid: `${classbasename}_fileinputbase_${counter}`,
                        style: "margin-left:1rem;"
                    }, 'Images');

                    //Append Show|Hide Button in BaseBtnAction
                    document.querySelector(`.${baseActionsName}`).appendChild(addselectimage);

                    //Set Data Input Id refer on Remove Button Section
                    removebtn.setAttribute('data-inputidrefer', `${inputype}_${counter}`);

                    //Incremetns Value for the counter
                    this.counterfileinput++;

                    //Set Heml Element indicate
                    htmlelementvalue = htmlelement === '' ? 'img' : htmlelement;
                    validationtype = 4;

                break;

                case 'descriptionsection':

                    this.counterdescriptioninput++;
                    counter = this.counterdescriptioninput;
                    htmlelementvalue = htmlelement === '' ? 'p' : htmlelement;
                    validationtype = 4;

                break;

                case 'htmlsection':

                    this.counterhtmlinput++;
                    counter = this.counterhtmlinput;
                    htmlelementvalue = htmlelement === '' ? 'div' : htmlelement;
                    validationtype = 6;

                break;

                case 'ctasection':

                    this.counterctainput++;
                    counter = this.counterctainput;
                    htmlelementvalue = htmlelement === '' ? 'a' : htmlelement;

                    //Add New Input for Link - CTA Link
                    let ctalink = this.addInput(classbasename, `${classdicchildrenname}-link`, `${labelmessage} Link`, `${placeholdermsg} Link`, addbtninput, inputype, counter, 8, inputvalue[0]);  

                    //Append CTA Link in All Inputs Div 
                    document.querySelector(`.${classbasename}`).appendChild(ctalink);

                break;

            }

            //Create Input Structure for All Inputs Div 
            let inputStructure = sectiontype !== 'filesection' 
            ? this.addInput(classbasename, classdicchildrenname, labelmessage, placeholdermsg, addbtninput, inputype, counter, validationtype, inputValueCTA) 
            : this.addInputFile(classbasename, 'fileinputbase', classdicchildrenname, inputype, labelmessage, placeholdermsg, counter, validationtype, inputValueCTA, filedata);

            //Append InputStructure in All Inputs Div 
            document.querySelector(`.${classbasename}`).appendChild(inputStructure);

            //Append InputStructure in All Inputs Div
           /*  if(sectiontype !== 'filesection'){

                //Create Input Structure for All Inputs Div 
                let htmlelementtag = this.addInput(classbasename, `htmlelement-${classdicchildrenname}`, 'HTML Element', 'Indicate a Tag', addbtninput, 'text', counter, 5, htmlelementvalue);

                document.querySelector(`.${classbasename}`).appendChild(htmlelementtag);

            }  */

            //Append InputStructure in All Inputs Div
            let htmlelementtag = this.addInput(classbasename, `htmlelement-${classdicchildrenname}`, 'HTML Element', 'Indicate a Tag', addbtninput, 'text', counter, 5, htmlelementvalue);

            document.querySelector(`.${classbasename}`).appendChild(htmlelementtag);

            //Increments
            this.countersection++;

            //Return Section DivBase
            return divbase;

        },
        addInput(
            classbasename, 
            classdicchildrenname, 
            labelmessage, 
            placeholdermsg, 
            addbtn = true, 
            inputype = 'text', 
            counter = 1, 
            validationtype = 4, 
            inputvalue = '',
            filedata = {}
        ){

            //Increment Value
            //this.counter++;

            //Set Inputid - name - class
            let inputrefer = `${classdicchildrenname}_${counter}`;

            //Set DivBase Input refer
            let divbaserefer = `${classdicchildrenname}_${counter}_${this.randomInputNum}`;

            //Div Element
            let div = htmlElements.createElement('div',  {
                class: `mt-3 ${classdicchildrenname} ${divbaserefer}`,
                data_inputorder: classdicchildrenname.includes('htmlelement-') ? (counter + 1) : counter,
                data_validation: validationtype
            });

            //Append Child - basediv
            document.querySelector(`.${classbasename}`).appendChild(div);

            //Label Element
            let label = htmlElements.createElement('label',  {
                class: 'form-label',
                for: inputrefer
            }, `${labelmessage}`);

            //Append Label
            document.querySelector('.' + divbaserefer).appendChild(label);

            //Check Input Type
            let inputAttributes = {};
            let element = '';

            //Input Attributes Object
            switch(inputype){

                case 'file':

                    //Html Element
                    element = 'input';

                    //Attributes
                    inputAttributes = {
                        type: 'file',
                        class: `form-control ${inputrefer}`,
                        id: inputrefer,
                        accept: 'image/*',
                        name: inputrefer,
                        value: inputvalue,
                        data_validation: validationtype,
                        disabled: true
                    };

                    //console.log(filedata);

                    //Set File Data for Update
                    if(filedata.hasOwnProperty('filenamenew') && Object.values(this.alldata).length > 0){

                        inputAttributes.data_filenameold = filedata.filenameold;
                        inputAttributes.data_filenamenew = filedata.filenamenew;
                        inputAttributes.data_filealt = filedata.filealt;
                        inputAttributes.data_imageid = filedata.imageid;

                    }

                break;

                case 'text':

                    //Html Element
                    element = 'input';

                    //Attributes
                    inputAttributes = {
                        type: 'text',
                        class: `form-control ${inputrefer}`,
                        id: inputrefer,
                        placeholder: placeholdermsg,
                        name: inputrefer,
                        value: inputvalue,
                        data_validation: validationtype
                    };

                    //Check by File Alte related
                    if(inputvalue.includes('file') || inputvalue.includes('File') || inputvalue.includes('img')){

                        //Set Read Only
                        inputAttributes.readonly = 'true';

                    }

                break;

                case 'textarea':

                    //Html Element
                    element = 'textarea';

                    //Attributes
                    inputAttributes = {
                        type: 'text',
                        class: `form-control ${inputrefer}`,
                        id: inputrefer,
                        placeholder: placeholdermsg,
                        name: inputrefer,
                        value: inputvalue,
                        data_validation: validationtype
                    };

                break;

                case 'htmlvalue':

                    //Html Element
                    element = 'htmlelement';

                    //Attributes
                    inputAttributes = {
                        type: 'text',
                        class: `form-control ${inputrefer} d-flex flex-row justify-content-between`,
                        id: inputrefer,
                        placeholder: placeholdermsg,
                        name: inputrefer,
                        value: inputvalue,
                        data_validation: validationtype
                    };

                break;

                default:

                    //Html Element
                    element = 'input';

                    //Attributes
                    inputAttributes = {
                        type: 'text',
                        class: `form-control ${inputrefer}`,
                        id: inputrefer,
                        placeholder: placeholdermsg,
                        name: inputrefer,
                        value: inputvalue,
                        data_validation: validationtype
                    };

                break;

            }

            //Input Element
            let input = htmlElements.createElement(element,  inputAttributes, inputvalue);

            //Append Input
            document.querySelector('.' + divbaserefer).appendChild(input);

            //Set File Data for Update
            if(filedata.hasOwnProperty('filenamenew') && Object.values(this.alldata).length > 0 && inputype === 'file'){

                //console.log(filedata.imageid);

                //Image Element
                let image = htmlElements.createElement('img', {
                    class: 'image-input',
                    data_filenameold: filedata.filenameold,
                    data_filenamenew: filedata.filenamenew,
                    data_filealt: filedata.filealt,
                    alt: filedata.filealt,
                    width: '190',
                    height: '90',
                    src: filedata.thumb_exist && filedata.imageid ? `${this.imagestoragepath}/${filedata.imageid}/thumb_${filedata.filenamenew}` : `${this.imagestoragepath}/${filedata.imageid}/original_${filedata.filenamenew}`
                });

                //Create Element
                input.after(image);

            }

            //Add Button Conditional
            if(addbtn){

                //Button Element
                let button = htmlElements.createElement('button',  {
                    type: 'button',
                    class: `mt-1 btn btn-danger btn-${classdicchildrenname}`,
                    data_refer: divbaserefer
                }, 'Remove');

                //Append Button
                document.querySelector('.' + divbaserefer).appendChild(button);

            }

            //Return Div Element
            return div;

        },
        addInputFile(classbasename, classbaechildren, classdicchildrenname, classfile, labelmessage, placeholdermsg, counter = 1, validationtype, inputvalue = '', filedata){

            //Div Element
            let div = htmlElements.createElement('div',  {
                class: `mt-3 ${classbaechildren} ${classbaechildren}${counter}`,
                id: `${classbasename}_${classbaechildren}_${counter}`,
                data_inputorder: counter
            });

            //Append Child - basediv
            document.querySelector(`.${classbasename}`).appendChild(div);

            //Basechildren for Input File Structure
            let checkInputValue = inputvalue === '' ? 'File Alt' : inputvalue;
            let basechildrenfilealt = this.addInput(classbasename, classdicchildrenname, labelmessage, placeholdermsg, false, 'text', counter, validationtype, checkInputValue);

            //Basechildren for Input File Structure
            let basechildrenfile = this.addInput(classbasename, classfile, labelmessage.replace(' Info', ''), placeholdermsg, false, 'file', counter, 9, '', filedata);

            //Input Text - Alt File
            div.appendChild(basechildrenfilealt);

            //Input File
            div.appendChild(basechildrenfile);

            //Return Div Element
            return div;

        },
        randomInputNumberGenerate(number = 100){

            //Get Time Stamps
            let datetime = new Date();

            //Seconds
            let seconds = datetime.getSeconds();
            let miliseconds = datetime.getMilliseconds();

            //Generate Rand Number
            this.randomInputNum = Math.round(Math.random() * number) +'_' + seconds + '_' + miliseconds;

            return this.randomInputNum;

        },
        removeMethod(element, action){

            //Get Element
            let el = action === 'removesection' 
            ? element.parentElement.parentElement.parentElement : element.parentElement.parentElement;

            //Confirm before remove
            let confirmremove = confirm('Favor confirmar a remoção ?');

            //Check Confirm
            if(confirmremove){

                //Check Update Route when Remove a Section
                if(element.getAttribute('data-section') === 'filesection'){

                    if(this.filedataformupdatelist.length > 0 && action === 'removesection' || 
                    this.filedataformlist.length > 0 && action === 'removesection'
                    ){

                        //Check if the Order BTN exist
                        if(document.querySelector('.orderbtn')){

                            //Disabled Order BTN
                            document.querySelector('.orderbtn').setAttribute('disabled', true);

                        }
                        
                        //Enabled Updated Button
                        this.disabled = false;
                    
                        //Remove value from array
                        if(element.getAttribute('data-actionremove') === 'update'){

                            this.removeFileFromSection(this.filedataformupdatelist, element);
                            this.removeFileFromSection(this.filedataformupdatelistpreview, element);

                            console.log(this.filedataformupdatelist);

                        }
                        
                        //Remove value from array
                        if(element.getAttribute('data-actionremove') === 'insert'){

                            this.removeFileFromSection(this.filedataformlist, element);
                            this.removeFileFromSection(this.filedataformlistpreview, element);

                            console.log(this.filedataformlist);

                        }
                        
                    
                    }

                }
                
                //Check Update Route when Remove a Container
                if(action === 'removecontent'){

                    //Decrement Order Content Default Value
                    --this.ordercontentdefault;

                    //Check Update Route for remove content from DB
                    if(element.getAttribute('data-actionremove') === 'update'){

                        //Get Content Id
                        let contentid = el.getAttribute('data-contentid');

                        //Remove Container from Table
                        this.sendDataActions(contentid, 'delete');

                    }

                }

                //Check BTN Form
                if(action === 'removesection' && this.formaction === 'update'){

                    //Check inputsections
                    let inputbase = [...el.parentElement.children];

                    //console.log(inputbase.length);

                    //Check Btn Form Disabled
                    if(document.querySelector('.btnform').hasAttribute('disabled')){

                        //Check BTN Form
                        if(document.querySelector('.btnform').getAttribute('disabled') === 'disabled' || 
                        document.querySelector('.btnform').getAttribute('disabled') !== null
                        ){

                            //Check if the Order BTN exist
                            if(document.querySelector('.orderbtn')){

                                //Disabled Order BTN
                                document.querySelector('.orderbtn').setAttribute('disabled', true);

                            }

                            //console.log(inputbase.length);

                            //Check Conditional for Enabled BTN Form
                            if(inputbase.length > 2){

                                //Enabled Updated Button
                                this.disabled = false;

                            }

                            //Check Conditional for Disabled BTN Form and show Error Message
                            if(inputbase.length === 2){

                                //Disabled Updated Button
                                this.disabled = true;

                                //Notification
                                alert('Favor add section para o Container ou removê-lo'); 

                            }

                        }

                    }
                    
                    //Check Btn Form Disabled
                    if(!document.querySelector('.btnform').hasAttribute('disabled')){

                        //console.log(inputbase.length);
                        //Check Conditional for Enabled BTN Form
                        if(inputbase.length === 2){

                            //Disabled Updated Button
                            this.disabled = true;

                            //Notification
                            alert('Favor add section para o Container ou removê-lo'); 

                        }

                    }

                }

                //Remove Element
                el.remove();

                return;

            }

            return;

        },
        removeFileFromSection(filelist, element){

            //Check Length
            if(filelist.length > 0){

                //console.log(filelist);
                //console.log(element);

                //Get FileData per Input File
                let file = filelist.find((valfile, indexfile) => {

                let objectindicate = valfile.hasOwnProperty('sectionfileinputid') ? valfile.sectionfileinputid : valfile.inputid;

                    if(objectindicate === element.getAttribute('data-inputidrefer')){

                        return valfile;

                    }

                });

                //Index
                let indexFile = filelist.indexOf(file);

                //console.log(indexFile);

                //Check IndexFile Value
                if(indexFile !== -1){

                    //console.log('Remove');

                    //Remove Old File
                    filelist.splice(indexFile, 1);

                }

            }

        },
        fileData(element){

            //Enabled Button
            this.disabled = false;

            //Clean Variable
            this.filedataform = {};

            //Get Input Type
            let inputType = element.target.getAttribute('type');

            //Check Type from input
            if(inputType === 'file'){

                //Get Data from File
                let filedata = element.target.files[0];

                //Check fileSize
                if(filedata.size >= this.alertgigabyte){

                    alert('Please send a smaller file size');

                    //Disabled Submit button
                    this.disabled = true;

                    return;

                }

                //Check type of the file
                if(!filedata.type.includes('image')){

                    alert('Please only send image type file');

                    //Disabled Submit button
                    this.disabled = true;

                    return;

                }

                //Structure File Data Object
                this.filedataform = {
                    name: 'filesection',
                    inputid: element.target.getAttribute('id'),
                    filename: filedata.name,
                    type: filedata.type.replace("image/", ""),
                    file64: '',
                    width: '',
                    height: ''
                };

                //Check if the input is for Update Image
                if(element.target.hasAttribute('data-imageid')){

                    //Set Update Data
                    this.filedataform.imageidtochange = element.target.getAttribute('data-imageid');
                    this.filedataform.filetoremove = element.target.getAttribute('data-filenamenew');

                }

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(filedata);
                reader.onload = e => {

                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                    
                        //Set File Width
                        this.filedataform.width = img.width;

                        //Set File Height
                        this.filedataform.height = img.height;

                        return this.filedataform;

                    };

                    img.onerror = (error) => {
                        
                        throw new Error(error)

                    };

                    img.src = src;
                };

                /* //Show input file alt
                document.getElementById('.logotipoinputalt').classList.remove('d-none');

                //Check if readonly is active
                if(document.getElementById(element.target.getAttribute('id')).hasAttribute('readonly')){

                    //Set Read Only
                    document.getElementById(element.target.getAttribute('id')).removeAttribute('readonly');

                } */

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(filedata);

                //Get Data from Promise
                file64Promise.then((val64) => {

                    //Set file64
                    this.filedataform.file64 = val64;

                    return this.filedataform;

                }).catch((error) => {

                    throw new Error(error);

                });

                //Send FileData for FileDataList Preview
                this.filedataformlistpreview.push(this.filedataform);

                //Send FileData for FileDataList
                return this.filedataformlist.push(this.filedataform);

            }

            return;

        },
        checkInputDataByFocus(element){

            //Conditional for use Order Routine
            if(element.target.nodeName === 'SPAN' && element.target.classList.contains('ordercontent')){

                //Check if the Order BTN exist
                if(document.querySelector('.orderbtn')){

                    //Disabled Order BTN
                    document.querySelector('.orderbtn').removeAttribute('disabled');

                    //Disabled Updated Button
                    return this.disabled = true;

                }

                return;

            }

            //===> Create Clear Validation for HtmlSection
            if(element.target.nodeName === 'CODE'){

                let codeValueChildren = [...element.target.children];

                //Enabled Submit Button
                if(codeValueChildren.length > 0){

                    return this.disabled = false;

                }
                
            }
            
            //===> Create Validation for Legends

            //Only Focus when is input element
            if(element.target.nodeName === 'INPUT' && element.target.getAttribute('type') === 'text' && element.target.value ||
            element.target.nodeName === 'TEXTAREA' && element.target.value || element.target.nodeName === 'LEGEND'
            ){
                //Check Value
                let dynamicValue = element.target.nodeName === 'LEGEND' ? element.target.textContent : element.target.value;

                //console.log(dynamicValue);

                //Validate Input data
                if(!this.inputValidationMethod(
                    parseInt(element.target.getAttribute('data-validation')),
                    dynamicValue,
                    element.target.getAttribute('id')
                )){

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(this.activeclass);
                    this.$refs.responsebasemessage.classList.add('errormessage');

                    //Set id for error message
                    if(element.target.nodeName !== 'LEGEND'){

                        //Instance Validation
                        //let inputValidation = new validation(3, '', '');

                        //Set Uppercase
                        let firstLetter = element.target.getAttribute('id').at(0).toUpperCase();
                        let capitalizaValue = element.target.getAttribute('id').replace(element.target.getAttribute('id').at(0), firstLetter);

                        //Render Erro Message
                        //inputValidation.createErrorMessageElement(element.target.getAttribute('id'), `Please inform the correct format for ${capitalizaValue}`);

                        //Element for append
                        let li = `<li class="list-group item my-1">Por favor informar o tipo de dado correto para ${capitalizaValue}</li>`;

                        //Append Element
                        $(li).appendTo(this.$refs.responsebasemessage.children);

                        //Clean Error Message
                        setTimeout(function(){

                            //Clean all Error Messages
                            [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                                //Remove element
                                value.remove();

                            });

                        }, 5000);

                    }else{

                        //Element for append
                        let li = `<li class="list-group item my-1">Favor apenas adicionar Letras e Números sem espaços</li>`;

                        //Append Element
                        $(li).appendTo(this.$refs.responsebasemessage.children);
                        
                        //Set Style Error Message
                        element.target.style.border = ".1rem solid #F00404";

                        //Clean Error Message
                        setTimeout(function(){

                            //Clean style Error Messages
                            element.target.removeAttribute('style');

                        }, 5000);

                    }

                    //Remove Base Response Message
                    this.removeResponseMessages();

                    //Disabled Submit Button
                    return this.disabled = true;

                }else{

                    //Enabled Submit Button
                    return this.disabled = false;

                }

            }

            return;

        },
        cloneHtmlContent(element){

            if(element.target.nodeName === 'CODE'){

                //Get Content
                this.htmlSectionCloneContent = element.target.innerHTML;
                //this.htmlSectionCloneContent = new DOMParser().parseFromString(element.target.innerHTML, 'text/html');
                /* this.htmlSectionCloneContent = element.target.firstElementChild !== null ? 
                element.target.firstElementChild.cloneNode(true) : element.target.cloneNode(true); */

                //const doc = new DOMParser().parseFromString(text, 'text/html');

                //console.log(this.htmlSectionCloneContent);

                //Get Parent Element
                let codeParent = element.target.parentElement.parentElement;

                //Get Code Clone Element
                let codeCloneElement = codeParent.lastElementChild;

                //Remove old Elements
                [...codeCloneElement.children].forEach((value)=> value.remove());

                // Create a new HTMLDocument object (using DOMParser or document.implementation)
                //const doc = document.implementation.createHTMLDocument('Generated Content');

                //Create Iframe
                /* let iframe = htmlElements.createElement(
                    'iframe',
                    {
                        id: 'htmlsection_iframe',
                        class: 'htmlsection_iframe'
                    }
                ); */

                //Set Clone Content
                //codeCloneElement.appendChild(iframe);

                // Get the iframe element and set its content to the generated HTMLDocument
                //const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                //Html Content
                /* const htmlContent = `
                    <!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8">
                        <title>Render Htmlsection Content</title>   
                    </head>
                    <body>
                        <pre>${this.htmlSectionCloneContent}</pre>
                    </body>
                    </html>
                `; */
                
                // Write the content into the HTMLDocument
                //doc.documentElement.innerHTML = this.htmlSectionCloneContent;
                //doc.documentElement.innerHTML = htmlContent;

                // Write the content into the iframe's document
                /* iframeDocument.open();
                iframeDocument.write(doc.documentElement.outerHTML);
                iframeDocument.close(); */
                //codeCloneElement.appendChild(this.htmlSectionCloneContent);
                //codeCloneElement.innerHTML = `<pre>${this.htmlSectionCloneContent}</pre>`;
                //codeCloneElement.outerHTML = this.htmlSectionCloneContent;
                //$(`<pre>${this.htmlSectionCloneContent}</pre>`).appendTo(codeCloneElement);
                //codeCloneElement.textContent = `${this.htmlSectionCloneContent}`;
                //$(codeCloneElement).html(this.htmlSectionCloneContent).text();
                codeCloneElement.innerHTML = $(codeCloneElement).html(this.htmlSectionCloneContent).text();

                //Enabled BTN
                this.disabled = false;

            }

        },
        inputValidationMethod(validationtype, inputvalue, inputid = ''){

            //Instance Validation
            let inputValidation = new validation(validationtype, '', '');

            //Validation Method
            let validInput;

            //Set Method
            switch(validationtype)
            {
                //Input Validation only for numbers
                case 2:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                
                break;

                //Input Validation All Types of data
                case 4:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                break;

                //Input Validation only Letters and Numbers
                case 5:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                break;

                //Input Validation All Types of data and Html Tags
                case 6:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                break;

                //Email Validation
                case 7:

                    let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                    validInput = emailRegex.test(inputvalue);
                    
                break;
                
                //URL Validation
                case 8:

                    //Check value for internal url or external url
                    if(inputvalue.includes('http') || inputvalue.includes('https')){

                        validInput = inputValidation.isValidUrl(inputvalue, inputid);

                    }else{ 

                        let internalurl = new RegExp(/^[a-z-0-9\/\-\#\_]+$/, "gm");
                        validInput = internalurl.test(inputvalue);

                    }

                break;

            }

            return validInput;

        },
        findByClass(value, classname){

            return [...value.children].find(valdiv => valdiv.classList.contains(classname));

        },
        findByNodeName(parentclass, nodename){

            return parentclass.find(valdiv => valdiv.nodeName === nodename);

        },
        spreadChildren(parentclass){

            return [...parentclass.children];

        },
        dataStructureResponse(responseObject){

            //Get Key and Value
            let entries = Object.entries(responseObject);

            //Loop response conditional
            for(const [key, value] of entries){

                switch(key)
                {

                    case 'attListData':

                        //Set Data
                        this.alldata = Array.isArray(value[0]) ? value[0] : value;

                        //Change Form Action and Text BTN when no more have container for update
                        if(Object.values(this.alldata).length === 0){

                            //Check current Route
                            if(this.formaction === 'update'){

                                //Set Form Action
                                this.formaction = 'insert';

                                //Change BTN Text
                                this.btntext = 'Submit';

                            }                     

                        }else{

                            //Set Update Form Action
                            this.formaction = 'update';
                            this.btntext = 'Update';

                        }

                        //Clean Variables
                        this.fieldsetdata = {};
                        this.fieldsetdata = {};
                        this.dataSection = {};
                        this.filedataformlist = [];
                        this.filedataformupdatelist = [];
                        this.contentidrefer = [];
                        this.orderbaselist = [];
                        this.orderbaselistoriginal = [];
                        this.ordercontentdefault = 0;
                        this.cardsContainers = [],
                        this.cardsNoFileContainers = [],
                        this.accordeonContainers = [],
                        this.slidecarouselContainers = [],

                        //Clean Data Preview
                        this.filedataformlistpreview = [];
                        this.filedataformupdatelistpreview = [];
                        
                        //Check if the element exist
                        if(document.querySelector('.orderbtn')){

                            //Remove Disabled
                            document.querySelector('.orderbtn').removeAttribute('disabled');

                        }
                        
                        //Render Pages Content
                        this.renderData(this.alldata, 'pagecontent');

                        //Get all Active BTNs element
                        let allBtnsActive = [...document.querySelectorAll('.btnactive')];

                        //Set Update Conditional for Active Container
                        allBtnsActive.forEach((value) => {

                            //Set Update
                            value.setAttribute('data-actionactive', 'update');

                        });

                        //Check Media Att Sequence
                        if(Array.isArray(value[1])){

                            //Set New Values for Media List
                            localStorage.setItem('medialist', JSON.stringify(value[1]));

                            //Get All Media Data
                            this.checkLocalStorage();

                        }
                    
                    break;

                    case 'successMessage':
                    case 'errorMessage':

                        //Clean Variables
                        this.fieldsetdata = {};
                        this.fieldsetdata = {};
                        this.dataSection = {};
                        this.filedataformlist = [];
                        this.filedataformupdatelist = [];
                        this.contentidrefer = [];
                        this.orderbaselist = [];
                        this.orderbaselistoriginal = [];
                        this.ordercontentdefault = 0;
                        this.cardsContainers = [],
                        this.cardsNoFileContainers = [],
                        this.accordeonContainers = [],
                        this.slidecarouselContainers = [],

                        //Clean Data Preview
                        this.filedataformlistpreview = [];
                        this.filedataformupdatelistpreview = [];
    
                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                        //Set Messages List
                        value.forEach((valmessage) => {

                            //Element for append
                            let li = `<li class="list-group item my-1">${valmessage}</li>`;

                            //Append Element
                            $(li).appendTo(this.$refs.responsebasemessage.children);

                        });
                        
                    break;

                }

            }

            //Remove Base Response Message
            this.removeResponseMessages();

            return this.alldata;

        },
        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('successmessage');
                document.querySelector('.responsebasemessage').classList.remove('errormessage');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        filesectionConditional(firstInputElement, secondInputElement, formaction){

            //Check FormAction
            if(formaction === 'preview' || formaction === 'previewinit'){

                return this.filesectionStructureFormAction(firstInputElement, secondInputElement, this.filedataformlistpreview, this.filedataformupdatelistpreview);

            }

            //Check Routine
            return this.filesectionStructureFormAction(firstInputElement, secondInputElement, this.filedataformlist, this.filedataformupdatelist);
           

        },
        filesectionStructureFormAction(firstInputElement, secondInputElement, filedataformlist, filedataformupdatelist){

            //File Data Var
            let fileData = [];

            //Check New Images and Change update images
            if(filedataformlist.length > 0 && filedataformupdatelist.length > 0){

                //console.log(this.filedataformlist);
                //console.log(this.filedataformupdatelist);
                //console.log(secondInputElement.getAttribute('id'));

                //Get FileData per Input File
                let fileDataReferUpdate = filedataformupdatelist.find(valfile => valfile.sectionfileinputid === secondInputElement.getAttribute('id'));

                //Get FileData per Input File
                let fileDataRefer = filedataformlist.find(valfile => valfile.inputid === secondInputElement.getAttribute('id'));

                /* console.log(fileDataReferUpdate);
                console.log(fileDataRefer); */

                //Check FileData from filedataformupdatelist and filedataformlist
                if(fileDataReferUpdate !== undefined && fileDataRefer !== undefined){

                    //Index File
                    let indexFileData;

                    //Get FileData per Input File
                    fileData = filedataformlist.find((valfile, indexfile) => {

                        if(valfile.inputid === secondInputElement.getAttribute('id')){

                            //Set Index
                            indexFileData = indexfile;

                            return valfile;

                        }

                    });

                    //Clean filedataformlist
                    filedataformlist.splice(indexFileData, 1);

                    console.log("Aqui");
                    console.log(filedataformlist);
                    /* console.log(fileData);
                    console.log(this.filedataformlist); */

                    //FirstInputElement => Page Title + Container Name + File ALt Data
                    //SecondInputElement => File Data
                    let sectionvalue = [firstInputElement, fileData];

                    return sectionvalue;

                }

                //Check FileData from filedataformupdatelist
                if(fileDataReferUpdate !== undefined && fileDataRefer === undefined){

                    console.log("Aqui2");
                    /* console.log(this.filedataformupdatelist);
                    console.log(secondInputElement.getAttribute('id')); */

                    //Get FileData per Input File
                    fileData = filedataformupdatelist.find(valfile => valfile.sectionfileinputid === secondInputElement.getAttribute('id'));

                    //Check FileData
                    if(Array.isArray(fileData.sectionvalue)){

                        fileData.sectionvalue = fileData.sectionvalue.length > 1 ? fileData.sectionvalue[1] : fileData.sectionvalue[0];

                    }

                    //FirstInputElement => File ALt Data
                    //SecondInputElement => File Data
                    let sectionvalue = [firstInputElement, fileData.sectionvalue];

                    return sectionvalue;

                }

                //Check FileData from filedataformlist
                if(fileDataRefer !== undefined && fileDataReferUpdate === undefined){

                    console.log("Aqui3");
                    /* console.log(secondInputElement.getAttribute('id'));
                    console.log(this.filedataformlist); */

                    //Get FileData per Input File
                    fileData = filedataformlist.find(valfile => valfile.inputid === secondInputElement.getAttribute('id'));

                    //FirstInputElement => Page Title + Container Name + File ALt Data
                    //SecondInputElement => File Data
                    let sectionvalue = [firstInputElement, fileData];

                    return sectionvalue;

                }    

            }

            //Check only for maintain update filedata
            if(filedataformlist.length === 0 && filedataformupdatelist.length > 0){

                console.log("Aqui4");

                //Get FileData per Input File
                fileData = filedataformupdatelist.find(valfile => valfile.sectionfileinputid === secondInputElement.getAttribute('id'));

                //Check FileData
                if(Array.isArray(fileData.sectionvalue)){

                    fileData.sectionvalue = fileData.sectionvalue.length > 1 ? fileData.sectionvalue[1] : fileData.sectionvalue[0];

                }

                //FirstInputElement => Page Title + Container Name + File ALt Data
                //SecondInputElement => File Data
                let sectionvalue = [firstInputElement, fileData.sectionvalue];

                return sectionvalue;

            }

            //Check only for new images
            if(filedataformlist.length > 0 && filedataformupdatelist.length === 0){

                console.log("Aqui5");
                /* console.log(this.filedataformlist);
                console.log(secondInputElement.getAttribute('id')); */

                //Get FileData per Input File
                fileData = filedataformlist.find(valfile => valfile.inputid === secondInputElement.getAttribute('id'));

                //FirstInputElement => Page Title + Container Name + File ALt Data
                //SecondInputElement => File Data
                let sectionvalue = [firstInputElement, fileData];

                return sectionvalue;

            }

            return null;

        },
        sendDataActions(id, formaction, activeaction = ''){

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Data Structure
            let dataForm = {
                pageid: this.datainfo[0].id,
                contentid: parseInt(id),
                contentlist: this.contentidrefer
            };

            if(activeaction !== ''){

                //Set Active Action
                dataForm.activeaction = activeaction;

            }

            //Set Fetch Action
            return this.actionFetchStructure(formaction, dataForm);

        },
        setAllContainersToSend(multiple, common){

            //Check lenght
            if(multiple.length > 0){

                //Check Multiple Containers List
                multiple.forEach((value) => {

                    //Remove Class to style element
                    //value.containerelement.classList.remove('w-100');
                    //value.containerelement.classList.remove('my-3');

                    //Push only html element to default List for Builder
                    common.push(value.containerelement);

                });

                return common;

            }

        },
        sendData(){

            //Disabled BTN
            this.disabled = true;

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Data Structure
            let dataForm = {
                layoutid: this.layoutactive,
                pageid: this.datainfo[0].id,
                pagescontentlist: []
            };

            //When is the update route
            if(this.contentidrefer.length > 0){

                dataForm.contentidlistreferupdate = this.formaction === 'previewinit' || this.formaction === 'preview' ? [...new Set(this.contentidreferpreview)]  : [ ...new Set(this.contentidrefer)];

            }

            //Organize Containers
            let commonContainers = [...document.querySelector('.fieldsetbase').children];

            //Filter Values
            let flterCommonContainers = commonContainers.filter((value) => !value.classList.contains('fieldset-multiple'));

            //Get Page Contents List | Order Content | Fieldset Content
            let fieldsetlist = this.allFiledsetContainerList;

            if(flterCommonContainers.length > 0){

                //Set Multiple Containers data
                this.setAllContainersToSend(this.cardsContainers, flterCommonContainers); 
                this.setAllContainersToSend(this.cardsNoFileContainers, flterCommonContainers); 
                this.setAllContainersToSend(this.accordeonContainers, flterCommonContainers); 
                this.setAllContainersToSend(this.slidecarouselContainers, flterCommonContainers); 

                //Associate values
                fieldsetlist = flterCommonContainers;

            }

            //Get Info from Fieldset Content
            if(fieldsetlist.length > 0){

                fieldsetlist.forEach((value) => {

                    //Get InputBase Div inputbase
                    let divContentInputGroup = {
                       
                        firststage: this.findByClass(value, 'inputbase'),
                        secondstage: this.findByClass(value, 'divaccordeon')

                    };

                    //Split Refer Class
                    let classNameInputBase = divContentInputGroup.firststage.getAttribute('class').split(' ');

                    //Class InputBase Interable
                    let inputBaseClass = classNameInputBase.find(valclass => valclass === `inputbase${value.getAttribute('data-contentid')}`);

                    //Set Third Stage
                    divContentInputGroup.thirdstage = this.spreadChildren(divContentInputGroup.secondstage);

                    //Get Content Name
                    divContentInputGroup.fourthstage = this.findByNodeName(divContentInputGroup.thirdstage, 'LEGEND');

                    //Get Order Div
                    divContentInputGroup.fifthystage = this.findByNodeName(divContentInputGroup.thirdstage, 'DIV');

                    //Get Active Div
                    divContentInputGroup.fifthystage.active = this.spreadChildren(this.findByClass(divContentInputGroup.fifthystage, 'activebase'));

                    //Get Order Custom Div
                    divContentInputGroup.fifthystage.order = this.findByClass(divContentInputGroup.fifthystage, 'orderbase');

                    //Get Custom Order Data
                    divContentInputGroup.sixthystage = this.findByClass(divContentInputGroup.fifthystage.order, 'ordercontent');

                    //Set Data for Content
                    this.fieldsetdata = {
                        contentname: divContentInputGroup.fourthstage.textContent.trim(),
                        contentoriginalposition: value.getAttribute('data-fieldset'),
                        contentoriginalorder: value.getAttribute('data-contentorder'),
                        contentid: value.getAttribute('data-contentid'),
                        contentpageid: parseInt(dataForm.pageid),
                        contentlayoutid: parseInt(dataForm.layoutid),
                        contentclassrefer: value.getAttribute('class'),
                        contentinputbaseclass: inputBaseClass,
                        contentordercustom: divContentInputGroup.sixthystage.textContent.trim(),
                        contentgroup: [],
                        contentactiveindicate: divContentInputGroup.fifthystage.active[1].textContent,
                        contentactiveaction: divContentInputGroup.fifthystage.active[1].getAttribute('data-actionactive') 
                    };

                    //console.log(divContentInputGroup.firststage);

                    //Check if the Div InputBase have a children
                    if([...divContentInputGroup.firststage.children].length > 1){

                        //Input Base children List
                        let inputBaseDivList = [...divContentInputGroup.firststage.children];

                        //console.log(inputBaseDivList);

                        //Remove Create Section Div
                        inputBaseDivList.splice(0, 1);

                        //Get InputBaseSection
                        inputBaseDivList.forEach((valinput) => {

                            //Find in children
                            let inputBase = [...valinput.children];

                            //console.log(valinput);

                            //Force Reload if the input is undefined
                            if(!inputBase[1] || inputBase[1] === undefined){

                                //Force reload
                                return window.location.replace(window.location.href);

                            }

                            //Get Inputs Div
                            let inputDivs = [...inputBase[1].children]; 

                            //console.log(inputDivs);

                            //Get HTML Element Input
                            let inputHtmlElement = inputDivs.find( valinput => valinput.getAttribute('class').includes('htmlelement'));

                            //Get element Input or TextArea
                            let inputElement = inputDivs.filter( valinput => !valinput.getAttribute('class').includes('htmlelement'));
                           
                            //console.log(inputElement);

                            //Input Element Value
                            let firstInputElement = {
                                value: ''
                            };
                            let secondInputElement = {
                                value: ''
                            };

                            //Get Section Type
                            let classDivSectionType = valinput.getAttribute('data-value');

                            //Get Value for HTML Element
                           //let htmlElementValue = classDivSectionType !== 'filesection' ? this.findByNodeName([...inputHtmlElement.children], 'INPUT') : 'img';
                           let htmlElementValue = this.findByNodeName([...inputHtmlElement.children], 'INPUT');

                            //Get Inputs by Section
                            switch(classDivSectionType){

                                //FileSection 
                                case 'filesection': 

                                    //Get Value for Input
                                    firstInputElement = [...inputElement[0].firstChild.children].find(inputval => inputval.nodeName === 'INPUT');
                                    secondInputElement = [...inputElement[0].lastChild.children].find(inputval => inputval.nodeName === 'INPUT');

                                break;

                                //CTA Data Section
                                case 'ctasection':

                                    //Get Value for Input
                                    firstInputElement = [...inputElement[0].children].find(inputval => inputval.nodeName === 'INPUT');
                                    secondInputElement = [...inputElement[1].children].find(inputval => inputval.nodeName === 'INPUT');


                                break;

                                //Description Section
                                //Html Section
                                case 'descriptionsection':
                                //case 'htmlsection':    

                                    //Get Value for Input
                                    firstInputElement = [...inputElement[0].children].find(inputval => inputval.nodeName === 'TEXTAREA');
                                    
                                break;

                                case 'htmlsection': 

                                    firstInputElement = [...inputElement[0].children];
                                    firstInputElement = [...firstInputElement[1].children].find(inputval => inputval.nodeName === 'PRE');
                                    firstInputElement = {
                                        value: firstInputElement.firstElementChild.innerText
                                    };
                           
                                break;

                                default:

                                    firstInputElement = [...inputElement[0].children].find(inputval => inputval.nodeName === 'INPUT');

                                break;

                            }

                            //Check if the input is not empty
                            if(firstInputElement.value){

                                //Get Section Name
                                let sectionName = [...inputBase[0].children];

                                //Check Section Name
                                let checkSectionName = !sectionName[0].textContent.trim().includes(this.fieldsetdata.contentname) ?
                                sectionName[0].textContent.trim() +' - '+ this.fieldsetdata.contentname + ' ' + this.fieldsetdata.contentid : 
                                sectionName[0].textContent.trim();

                                //Data Info By Section
                                this.dataSection = {
                                    sectionname: checkSectionName,
                                    sectiontype: classDivSectionType,
                                    sectionclassrefer: valinput.getAttribute('class'),
                                    sectionidrefer: valinput.getAttribute('id'),
                                    sectionorder: valinput.getAttribute('data-inputobaseorder'),
                                    sectionhtmlelement: htmlElementValue.value.toLowerCase(),
                                    sectionvalue: [],
                                    sectioncontentclassrefer: this.fieldsetdata.contentclassrefer
                                };

                                //Check Data from especific section
                                switch(classDivSectionType){

                                    //CTA Data Section
                                    case 'ctasection':

                                        //FirstInputElement => Link
                                        //SecondInputElement => CTA Name Button
                                        this.dataSection.sectionvalue = [firstInputElement.value, secondInputElement.value];

                                    break;

                                    //FileSection
                                    case 'filesection':
                                      
                                        //Set File Input Id
                                        this.dataSection.sectionfileinputid = secondInputElement.getAttribute('id');

                                        //FileLocation Media
                                        let filelocation = {
                                            page: this.datainfo[0].title,
                                            container: this.fieldsetdata.contentname,
                                            filealt: firstInputElement.value
                                        };

                                        //Set Section value
                                        this.dataSection.sectionvalue = this.filesectionConditional(filelocation, secondInputElement, this.formaction);

                                        //Check section value Object Property
                                        if(this.dataSection.sectionvalue === undefined || this.dataSection.sectionvalue === null){

                                            //Send Message
                                            alert('Favor add Imagem');

                                            return;

                                        }

                                    break;

                                    //Default
                                    default:

                                        this.dataSection.sectionvalue = [firstInputElement.value];

                                    break;

                                }

                                //Push Values
                                this.fieldsetdata.contentgroup.push(this.dataSection);    

                            }

                        });

                    }

                    //Set Info from Fieldset Content
                    dataForm.pagescontentlist.push(this.fieldsetdata);

                });

                //Set Fetch Action
                return this.actionFetchStructure(this.formaction.toLowerCase(), dataForm);

            }

            return;

        },
        actionFetchStructure(formaction, dataForm){

            //Set Route
            let method;
            let urlmethod;

            //Form Action
            switch(formaction.toLowerCase()){

                case 'insert':

                    method = 'POST';
                    urlmethod = this.pagescontentcreate;

                break;

                case 'update':

                    method = 'PUT';
                    urlmethod = this.pagescontentupdate;

                break;

                case 'delete':

                    method = 'DELETE';
                    urlmethod = this.pagescontentremove;

                break;

                case 'active':

                    method = 'PUT';
                    urlmethod = this.pageactive;

                break;

                case 'order':

                    method = 'PUT';
                    urlmethod = this.pagescontentorder;

                break;

                case 'preview':
                case 'previewinit':    

                    method = 'POST';
                    urlmethod = this.pagestorepreview;

                    //Set Preview Active Routine
                    dataForm.activeroutine = this.previwActiveRoutine;

                break;

                case 'previewactive':

                    method = 'PATCH';
                    urlmethod = this.pageactivepreview;

                break;

            }

            //Send Data
            let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);
                
            //Check Response
            response.then((value) => {

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Check Preview Routine
                if(formaction === 'preview' || formaction === 'previewactive' || formaction === 'previewinit'){

                    //Set textContent from Form Button
                    this.formaction = this.contentidrefer.length > 0 ? 'update' : 'insert';

                    //Check response from Preview Routine
                    if(value.hasOwnProperty('confirmPreview') && value.confirmPreview){

                        //Send to preview page
                        if(formaction === 'preview'){

                            //List all Active Base Divs
                            let activeDivBase = [...document.querySelectorAll('.activebase')];

                            //Remove Active|Desactive Preview Class from Active Div
                            activeDivBase.forEach((value) => {

                                //Remove previewactive
                                if(value.classList.contains('previewactive')){

                                    value.classList.remove('previewactive');

                                }

                                //Remove previewdesactive
                                if(value.classList.contains('previewdesactive')){

                                    value.classList.remove('previewdesactive');

                                }

                            });

                            //Clean Data
                            this.filedataformlistpreview = [];
                            //this.filedataformupdatelistpreview = [];

                            //Enabled BTN
                            this.disabled = false;

                            //Get Data for new Render after Preview
                            if(value.hasOwnProperty('attListData')){

                                //Set New Data
                                this.alldata = value.attListData;

                                //Clean Content Id refer
                                this.contentidreferpreview = [];

                                //Render Pages Content
                                this.renderData(this.alldata, 'pagepreview');
                              
                            }
                            
                            //Redirect for Preview Page
                            window.open(this.pagepreview + this.datainfo[0].id, "_blank");

                            //Set ActivePreview Routine
                            this.previwActiveRoutine = false;

                        }
                        
                        return;

                    }

                    //Show Error Message
                    alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    return;

                }

                //Generate a Response
                return this.dataStructureResponse(value);

            }).catch((error) => {

                //Show Error Message
                alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Enabled BTN
                this.disabled = false;

                throw new Error(error);

            })

        }

    },
    computed:{

        computedAllData(){

            return this.alldata;

        },
        computedRandomInputNumber(){

            return this.randomInputNum;

        },
        computedFiledataForm(){

            return this.filedataform;

        },
        computedAllMediaFiles(){

            return this.allmediafiles; 

        },
        computedFileFormList(){

            return this.filedataformlist;

        },
        computedFileDataFormUpdateList(){

            return this.filedataformupdatelist;

        },
        computedFormaction(){

            return this.formaction;

        },
        computedActivePreviewRoutine(){

            return this.previwActiveRoutine;

        },
        computedFileFormListPreview(){

            return this.filedataformlistpreview;

        },
        computedFileDataFormUpdateListPreview(){

            return this.filedataformupdatelistpreview;

        },
        computedContentIdRefer(){

            return this.contentidrefer;

        },
        computedContentIdReferPreview(){

            return this.contentidreferpreview;

        },
        computedSlidecarouselGroup(){

            return this.slidecarouselContainers;

        },
        computedCardsGroup(){

            return this.cardsContainers;

        },
        computedCardsNoFileGroup(){

            return this.cardsNoFileContainers;

        },
        computedAccordeonGroup(){

            return this.accordeonContainers;

        },
        computedHtmlSectionCloneContent(){

            return this.htmlSectionCloneContent;

        }

    },
    watch:{

        computedAllData(){},
        computedRandomInputNumber(){},
        computedFiledataForm(){},
        computedAllMediaFiles(){},
        computedFileFormList(){},
        computedFileDataFormUpdateList(){},
        computedFormaction(){},
        computedActivePreviewRoutine(){},
        computedFileFormListPreview(){},
        computedFileDataFormUpdateListPreview(){},
        computedContentIdRefer(){},
        computedContentIdReferPreview(){},
        computedSlidecarouselGroup(){},
        computedCardsGroup(){},
        computedCardsNoFileGroup(){},
        computedAccordeonGroup(){},
        computedHtmlSectionCloneContent(){}

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,
        modal: Modal,
        mediaList: MediaList,
        insertMedia: InsertMedia

    }

}

</script>